import { create } from "zustand";
import {
  allChecksType,
  areaRiskType,
  AssetsState,
  CurrentAssets,
  budgetCategoryObjType,
  departmentObjType,
  fireRiskProcessObjType,
  fireRiskSubProcessObjType,
  hospitalRiskType,
  initialChecks,
  initialEquipment,
  initialRiskAssObject,
  legalContracttypesObjType,
  OrgUserType,
  policyTagsObjType,
  premisesApiResponse,
  regionObjectType,
  riskobjectType,
  rolesObjType,
  UserObject,
  Training,
  Test,
  Task,
  Trainee,
  QuizQuestion,
  ApiRes,
  maintenance,
  MaintenanceTask,
  DashboardDataType,
  FetchDashboardArgs,
  FireDrill,
  CreateCheckListForm,
  CheckListItem,
  AuditFormData,
  Audit,
  PerformAuditData,
  EquipmentObjType,
  ActionReport,
  LawsAndRegulationsAudit,
  AuditReminder,
  CreateAuditFormData,
  UpdateAuditFormData,
  LawsAndRegulationsTask,
  CreateTaskFormData,
  UpdateTaskFormData,
  StaffOfIndependentUnits,
  CreateStaffFormData,
  UpdateStaffFormData,
  IndependentUnit,
  PremiseWithIndependentUnits,
  EquipmentManagementTask,
  ExternalAgency,
  AssetInventory,
  ContractorVendorManagement,
  UtilityAssetTypeListType,
  SpaceUtilization,
  roundPlanningType,
  EquipmentInventory,
} from "../types/api";
import {
  createasr,
  createAssets,
  createChecks,
  createEquipment,
  createhwr,
  createMaintenance,
  createRiskAssessment,
  deleteRiskAssessment,
  deleteASR,
  deleteChecks,
  deleteHwr,
  fetchASRScore,
  fetchHWRScore,
  filterAssetsByFloor,
  filterAssetsByPremises,
  filterAssetsByRegion,
  getAllASR,
  getAllAssets,
  getAllChecks,
  getAllHwr,
  getAllMaintenance,
  getAssessmentScore,
  getOneAssets,
  getOneMaintenance,
  getRiskAssesmentById,
  getRiskAssesments,
  getUsers,
  searchAssets,
  searchRiskAssessment,
  updateASR,
  updateAssets,
  updateChecks,
  updateHwr,
  updateRiskAssessment,
  getAllTrainings,
  //searchTrainings,
  createTraining,
  updateTraining,
  getTrainingById,
  toggleTrainingStatus as toggleTrainingStatusApi,
  deleteTraining as deleteTrainingApi,
  updateAttendance as updateAttendanceApi,
  createTest,
  updateTest,
  //getTestById,
  submitTest,
  getTestByTrainingIdApi,
  getAllTests,
  //getTestsByTrainerApi,
  createCheck,
  getAllCheck,
  deleteCheck,
  searchCheck,
  getCheck,
  // Laws and Regulations Audits API functions
  getAllLawsRegulationsAudits,
  getLawsRegulationsAuditById,
  createLawsRegulationsAudit,
  updateLawsRegulationsAudit,
  deleteLawsRegulationsAudit,
  searchLawsRegulationsAudits,
  uploadAuditReportFile,
  uploadAuditClosureFile,
  getAuditReminders,
  // Laws and Regulations Tasks API functions
  getAllLawsRegulationsTasks,
  getLawsRegulationsTaskById,
  createLawsRegulationsTask,
  updateLawsRegulationsTask,
  deleteLawsRegulationsTask,
  searchLawsRegulationsTasks,
  filterLawsRegulationsTasks,
  filterLawsRegulationsTasksByRegion,
  completeLawsRegulationsTask,
  taskRisk,
  getAllEquipmentManagementTask,
  updateEquipmentManagementTask,
  getAllAuditsHandler,
  getAllHazardousVulnerability,
  createHazardousVulnerability,
  getHazardousVulnerabilityById,
  updateHazardousVulnerability,
  deleteHazardousVulnerability,
  getAllExternalAgencies,
  createExternalAgency,
  updateExternalAgency,
  deleteExternalAgency,
  searchExternalAgencies,
  exportExternalAgencies,
  deleteAssetsInventory,
  updateAssetsInventory,
  createAssetInventory,
  getAssetInventory,
  getAssetsInventoryById,
  createContractorVendor,
  getContractorVendors,
  updateContractorVendor,
  deleteContractorVendor,
  getContractorVendorById,
  createUtilityAssetType,
  getAllUtilityAssetTypes,
  deleteUtilityAssetType,
  updateUtilityAssetType,
  createSpaceUtilization,
  getSpaceUtilization,
  getSpaceUtilizationById,
  updateSpaceUtilization,
  deleteSpaceUtilization,
  getSpaceUtilizationByProject,
  getSpaceUtilizationByPremise,
  createRoundPlanning,
  updateRoundPlanning,
  deleteRoundPlanning,
  getAllRoundPlanning,
  getOneRoundPlanning,
  getAllEquipmentManagementData,
  getPremiseOptions,
  PremiseOption,
} from "../service/api";
import { handleApiError, isDefined } from "../common/utils";
import axiosInstance from "../common/axiosInstance";
import { toast } from "react-toastify";

// interface JwtPayload {
//   id?: string; // Changed from tenantId to id
//   sub?: string;
//   roles?: string[];
//   tenant_name?: string;
//   [key: string]: any;
// }
interface TrainingState {
  userRole: "trainer" | "trainee" | "SuperAdmin" | "OrgAdmin";
  trainings: Training[];
  tests: Test[];
  loading: boolean;
  error: string | null;
  training: Training | null;
  fetchTrainings: (params?: {
    type?: "upcoming" | "past" | "all";
    limit?: number;
    skip?: number;
    sort?: string;
    where?: object;
    region?: string;
    premises?: string;
    startDate?: string;
    endDate?: string;
    roleFilter?: "trainee" | "trainer";
    includeStats?: boolean;
  }) => Promise<any>;
  //searchTrainings: (keyword: string) => Promise<Training[]>;
  createTraining: (data: Omit<Training, "id">) => Promise<Training>;
  updateTraining: (id: string, data: Partial<Training>) => Promise<Training>;
  toggleTrainingStatus: (id: string) => Promise<Training>;
  deleteTraining: (id: string) => Promise<void>;
  updateAttendance: (
    id: string,
    updates: {
      traineeId: string;
      attendance: "Present" | "Absent";
      testCategory: "Pre-Test" | "Post-Test";
    }[],
    tenantId: string,
  ) => Promise<void>;

  createTest: (data: Omit<Test, "id">) => Promise<Test>;
  updateTest: (id: string, data: Partial<Test>) => Promise<Test>;
  //getTestById: (id: string) => Promise<Test>;
  submitTest: (
    testId: string,
    answers: { questionId: number; selectedOption: number }[],
    traineeId: string,
  ) => Promise<{ score: number; message: string }>;
  fetchTrainingById: (id: string) => Promise<Training>;
  getTestByTrainingId: (trainingId: string) => Promise<Test[]>;
  // getTestsByTrainer: () => Promise<Test[]>;
  fetchAllTests: () => Promise<Test[]>;
}
interface NavState {
  isNav: boolean;
  setNav: (val: boolean) => void;
  logState: () => void;
}

export const useSidenavStore = create<NavState>((set, get) => ({
  isNav: false,
  setNav: (val) => {
    set((state: NavState) => ({ isNav: val }));
  },
  logState: () => {
    const state = get();
  },
}));

// Demo store code
// This code is for reference purpose
interface IfetchUsers {
  users: UserObject[];
  loadingUsers: boolean;
  errorUsers: string;
  fetchUsers: (param?: UserObject) => Promise<void>;
  resetUsers: () => void;
}

export const useBookingListStore = create<IfetchUsers>((set, get) => ({
  users: [],
  loadingUsers: false,
  errorUsers: "",
  fetchUsers: async (param?: UserObject) => {
    set({ loadingUsers: true, errorUsers: "" });
    try {
      const response = await getUsers(param);
      if (response.status === 200) {
        const resList: UserObject[] = Array.isArray(response.data.message)
          ? response.data.message
          : [];
        set({ users: resList, loadingUsers: false });
      } else {
        set({ errorUsers: response.data.resMessage, loadingUsers: false });
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ errorUsers: err.message, loadingUsers: false });
      } else {
        set({ errorUsers: "An unknown error occurred", loadingUsers: false });
      }
    }
  },
  resetUsers: () => {
    set({ users: [], loadingUsers: false, errorUsers: "" });
  },
}));

// premises
interface premises {
  addPremisesStore: Record<string, any>;
  allModules: Record<string, any>;
  premisesModules: Record<string, any>;
  premiseData: any;
  loading: boolean;
  optionsLoading: boolean;
  error: boolean;
  allPremises: premisesApiResponse[];
  premiseOptions:PremiseOption[];
  fetchPremiseOptions: () => Promise<void>;
  premiseMap: Record<string, any>;
  setPremises: (data: Record<string, any>) => void;
  setAllModules: (data: Record<string, any>) => void;
  setPremisesModules: (data: Record<string, any>) => void;
  handelSubmitPremises: () => void;
  setPremiseData: (data: any) => void;
  updatePremise: (data: any) => void;
  fetchPremises: () => Promise<void>;
}

interface TaskState {
  tasks: Task[];
  tasksWithFilter: Task[];
  loading: boolean;
  error: string | null;
  currentTask: Task | null;

  fetchTasks: (filters?: {
    regionId?: string;
    premisesId?: string;
  }) => Promise<void>;
  fetchTaskById: (id: number) => Promise<Task | null>;
  addTask: (task: Omit<Task, "id">) => Promise<void>;
  updateTask: (id: string, task: Partial<Task>) => Promise<void>;
  deleteTask: (id: string) => Promise<void>;
  filterTask: (filterData: any) => Promise<void>;
  searchTasks: (keyword: string) => Promise<void>;
  setCurrentTask: (task: Task | null) => void;
  resetTasks: () => void;
  resetFilter: () => void;
}

interface LawsAndRegulationsTaskState {
  tasks: LawsAndRegulationsTask[];
  loading: boolean;
  error: string | null;
  currentTask: LawsAndRegulationsTask | null;

  fetchTasks: () => Promise<void>;
  fetchTaskById: (id: string) => Promise<void>;
  createTask: (task: CreateTaskFormData) => Promise<void>;
  updateTask: (id: string, task: UpdateTaskFormData) => Promise<void>;
  deleteTask: (id: string) => Promise<void>;
  searchTasks: (keyword: string) => Promise<void>;
  filterTasks: (filters: any) => Promise<void>;
  filterTasksByRegion: (regionName: string) => Promise<void>;
  completeTask: (id: string) => Promise<void>;
  setCurrentTask: (task: LawsAndRegulationsTask | null) => void;
  clearTasks: () => void;
}

export const usePremisesStore = create<premises>((set, get) => ({
  addPremisesStore: {},
  allModules: {},
  error: false,
  loading: false,
  optionsLoading:false,
  premisesModules: {},
  premiseData: {},
  allPremises: [],
  premiseMap: {},
  premiseOptions: [],


  setPremises: (data) =>
    set((state) => ({
      addPremisesStore: { ...state.addPremisesStore, ...data },
    })),
  setAllModules: (data) =>
    set((state) => ({ allModules: { ...state.allModules, ...data } })),
  setPremisesModules: (data) =>
    set((state) => ({
      premisesModules: { ...state.premisesModules, ...data },
    })),
  setPremiseData: (data) => set({ premiseData: data }),

  fetchPremises: async () => {
    set({ loading: true, error: false });
    try {

      const response = await axiosInstance.get(`/api/premises`);
      set({ allPremises: response.data, loading: false });
      set({
        premiseMap: response.data.reduce((acc: any, premise: any) => {
          acc[premise._id] = premise.premisesName;
          return acc;
        }, {}),
      });
    } catch (error) {
      console.error("Error fetching premises:", error);
    } finally {
    }
  },

  fetchPremiseOptions: async () => {
    set({ optionsLoading: true });

    try {
      const premiseOptions = await getPremiseOptions();
      set({ premiseOptions });
    } catch (error) {
      console.error("Error fetching premise options:", error);
      set({ premiseOptions: [] });
    } finally {
      set({ optionsLoading: false });
    }
  },

  handelSubmitPremises: async () => {
    try {
      const { addPremisesStore, allModules, premisesModules } = get();

      const allModulesArray = Object.values(allModules);
      const premisesModulesArray = Object.values(premisesModules);
      const payload = {
        ...addPremisesStore,
        modules: allModulesArray,
        premisesModules: premisesModulesArray,
      };

      const response = await axiosInstance.post(`/api/premises`, payload);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  },
  updatePremise: async (id: any) => {
    try {
      const { addPremisesStore, allModules, premisesModules } = get();
      const allModulesArray = Object.values(allModules);
      const premisesModulesArray = Object.values(premisesModules);
      const payload = {
        ...addPremisesStore,
        modules: allModulesArray,
        premisesModules: premisesModulesArray,
      };
      const response = await axiosInstance.put(
        `/api/premises/${id}`,
        payload,
      );
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  },
}));

export const useTaskStore = create<TaskState>((set, get) => ({
  tasks: [],
  tasksWithFilter: [],
  loading: false,
  error: null,
  currentTask: null,

  fetchTasks: async (filters?: { regionId?: string; premisesId?: string }) => {
    set({ loading: true, error: null });
    try {
      const params: any = {};

      if (filters?.regionId) {
        params.regionId = filters.regionId;
      }

      if (filters?.premisesId) {
        params.premisesId = filters.premisesId;
      }
      const response = await axiosInstance.get(`/api/task`, {
        params,
      });

      const transformedData: Task[] = response.data.map((item: any) => ({
        id: item.id,
        topic: item.topic,
        task: item.task,
        frequency: item.frequency,
        responsibility: item.responsibility,
        fromDueDate: item.fromDueDate,
        premises: item.premises,
        toDueDate: item.toDueDate,
        daysRemaining: item.daysRemaining,
        premisesId: item.premisesId,
        tenantId: item.tenantId,
        reference: item.reference,
        furtherDetails: item.furtherDetails,
        isRecurring: item.isRecurring || false,
        module: item.module || "",
        nextExecutionDate: item.nextExecutionDate || null,
        displayDate: item.displayDate || null,
        status: item.status || "Pending",
      }));

      set({ tasks: transformedData, loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
    }
  },

  fetchTaskById: async (id: number) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.get(`/api/task/${id}`);

      const taskData: Task = {
        id: response.data.id,
        topic: response.data.topic,
        task: response.data.task,
        frequency: response.data.frequency,
        responsiblePersonList: response.data.responsiblePersonList || "",
        fromDueDate: response.data.fromDueDate,
        // toDueDate: response.data.toDueDate,
        premises: response.data.premises,
        reference: response.data.reference,
        daysRemaining: response.data.daysRemaining || undefined,
        furtherDetails: response.data.furtherDetails,
        isRecurring: response.data.isRecurring || false, // Added as required by Task interface
        nextExecutionDate: response.data.nextExecutionDate || null,
        displayDate: response.data.displayDate || null,
        status: response.data.status || "Pending",
        tenant_name: response.data.tenant_name || undefined,
        createdDate: response.data.createdDate || undefined,
        updatedAt: response.data.updatedAt || undefined,
      };

      set({ currentTask: taskData, loading: false });
      return taskData;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      return null;
    }
  },

  addTask: async (task: Omit<Task, "id">) => {
    set({ loading: true, error: null });
    try {
      const payload = {
        ...task,
        isRecurring: task.isRecurring || false,
        frequency: task.frequency || "",
      };

      const response = await axiosInstance.post(`/api/task`, payload);
      if (
        response.data.success ||
        response.status === 200 ||
        response.status === 201
      ) {
        await get().fetchTasks();
        toast.success("Task created successfully");
      }
    } catch (error: any) {
      toast.error("Failed to create task");
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      throw error;
    }
  },

  updateTask: async (id: string, task: Partial<Task>) => {
    set({ loading: true, error: null });
    try {
      const payload = {
        ...task,
        isRecurring: task.isRecurring || false,
        frequency: task.frequency || "",
      };

      const response = await axiosInstance.put(
        `/api/task/${id}`,
        payload,
      );

      if (response.data.success || response.status === 200) {
        await get().fetchTasks();
        toast.success("Task updated successfully");
      }
    } catch (error: any) {
      toast.error("Failed to update task");
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      throw error;
    }
  },

  deleteTask: async (id: string) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.delete(`/api/task/${id}`);

      if (response.status === 200) {
        await get().fetchTasks();
        toast.success("Task deleted successfully");
      }
    } catch (error: any) {
      toast.error("Failed to delete task");
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      throw error;
    }
  },

  filterTask: async (filterData) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.post(
        `/api/task/filter`,
        filterData,
      );
      set({ tasksWithFilter: response.data, loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
    }
  },

  searchTasks: async (keyword: string) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosInstance.get(
        `/api/task/search/${keyword}`,
      );

      const transformedData: Task[] = response.data.map((item: any) => ({
        id: item.id,
        topic: item.topic,
        task: item.task,
        frequency: item.frequency,
        responsibility: item.responsibility,
        fromDueDate: item.fromDueDate,
        toDueDate: item.toDueDate,
        premises: item.premises,
        daysRemaining: item.daysRemaining,
        reference: item.reference,
        furtherDetails: item.furtherDetails,
        isRecurring: item.isRecurring || false,
        nextExecutionDate: item.nextExecutionDate || null,
        displayDate: item.displayDate || null,
        status: item.status || "Pending",
      }));

      set({ tasks: transformedData, loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
    }
  },

  resetFilter: () => {
    set({ tasksWithFilter: [], loading: false });
  },

  setCurrentTask: (task: Task | null) => set({ currentTask: task }),
  resetTasks: () =>
    set({ tasks: [], loading: false, error: null, currentTask: null }),
}));

// Replace the old useTrainingStore with the updated version
export const useTrainingStore = create<TrainingState>((set) => ({
  trainings: [],
  tests: [],
  loading: false,
  error: null,
  training: null,
  userRole: "trainer",

  fetchTrainings: async (params = {}) => {
    set({ loading: true, error: null });
    try {

      type TrainingQueryParams = {
        type?: "upcoming" | "past" | "all";
        limit?: number;
        skip?: number;
        sort?: string;
        where?: Record<string, unknown>;
        [key: string]: unknown;
      };

      const finalParams: TrainingQueryParams = {
        ...(params as TrainingQueryParams),
      };

      const existingWhere =
        typeof finalParams.where === "object" && finalParams.where !== null
          ? finalParams.where
          : {};

      const hasModuleTypeFilter =
        Object.prototype.hasOwnProperty.call(finalParams, "moduleType") ||
        Object.prototype.hasOwnProperty.call(existingWhere, "moduleType");

      finalParams.where = {
        ...existingWhere,
        ...(hasModuleTypeFilter ? {} : { moduleType: "fire_safety" }),
      };

      // ✅ No need to fetch tenantId or use it in the query anymore
      const response = await getAllTrainings(finalParams);

      const rawData = response.data as Partial<{
        success: boolean;
        totalCount: number;
        results?: Training[];
        stats?: {
          totalTrainings: number;
          upcomingSessionsCount: number;
          pastTrainingsCount: number;
          pendingSessionsCount: number;
        };
      }>;

      const data = {
        success: rawData.success ?? false,
        totalCount: rawData.totalCount ?? 0,
        results: rawData.results ?? [],
        stats: rawData.stats,
      };

      if (data.success && data.results) {
        set({ trainings: data.results, loading: false });
        return data;
      }

      set({ trainings: [], loading: false });
      return { results: [], totalCount: 0 };
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to fetch trainings",
        loading: false,
      });
      throw err;
    }
  },

  // searchTrainings: async (keyword: string) => {
  //   set({ loading: true, error: null });
  //   try {
  //     const response = await searchTrainings(keyword);
  //     const trainings = response.data as unknown as Training[];
  //     set({ trainings, loading: false });
  //     return trainings;
  //   } catch (err) {
  //     set({
  //       error:
  //         err instanceof Error ? err.message : "Failed to search trainings",
  //       loading: false,
  //     });
  //     throw err;
  //   }
  // },

  createTraining: async (data: Omit<Training, "id">) => {
    set({ loading: true, error: null });
    try {
      // Validate required fields
      const validatedData: Omit<Training, "id"> = {
        topic: data.topic ?? "",
        category: data.category ?? "Fire Safety",
        date: data.date ?? "",
        files: Array.isArray(data.files) ? data.files : [],
        tests: data.tests ?? [],
        duration: data.duration ?? "",
        method: data.method ?? "",
        instructor: Array.isArray(data.instructor)
          ? data.instructor.map((inst) => ({
              trainerId: inst.trainerId || "",
              trainerEmployeeId: inst.trainerEmployeeId || "",
              trainerName: inst.trainerName || "",
            }))
          : [],
        trainees: Array.isArray(data.trainees)
          ? data.trainees.map((trainee) => ({
              traineeId: trainee.traineeId,
              traineeEmployeeId: trainee.traineeEmployeeId || "",
              name: trainee.name,
              email: trainee.email || "", // Ensure email is included
              department: trainee.department,
              role:
                typeof trainee.role === "object" && trainee.role?.$oid
                  ? trainee.role.$oid
                  : trainee.role || "",
              roleName: trainee.roleName || undefined,
              attendance: trainee.attendance || "Absent",
              results: trainee.results || {
                preTestId: null,
                postTestId: null,
                preTestScore: null,
                postTestScore: null,
              },
            }))
          : [],
        status: data.status ?? "Active",
        createdAt: data.createdAt ?? new Date().toISOString(),
        updatedAt: data.updatedAt ?? new Date().toISOString(),
        tenantId: data.tenantId ?? "",
        moduleType: data.moduleType ?? "fire_safety",
        premises: Array.isArray(data.premises) ? data.premises : [],
        regions: Array.isArray(data.regions) ? data.regions : [],
        startTime: data.startTime ?? "",
        endTime: data.endTime ?? "",
      };

      // Validate or fetch tenantId
      let submitTenantId = validatedData.tenantId;
      if (!submitTenantId || !/^[a-f\d]{24}$/i.test(submitTenantId)) {
        console.warn(
          "Invalid or missing tenantId in data. Attempting to fetch from JWT or /api/tenant/me",
        );

        const response = await axiosInstance.get(`/api/tenant/me`);
        submitTenantId = response.data.message.id;
        if (!submitTenantId || !/^[a-f\d]{24}$/i.test(submitTenantId)) {
          throw new Error("No valid tenant ID found. Please log in again.");
        }
        validatedData.tenantId = submitTenantId;
      }
      const response = await axiosInstance.post(
        `/api/training`,
        validatedData,
      );

      if (!response.data.success) {
        throw new Error(response.data.error || "Failed to create training");
      }

      const newTraining: Training = {
        ...response.data.data,
        id: response.data.data.id,
      };

      set((state) => ({
        trainings: [...state.trainings, newTraining],
        loading: false,
      }));
      return newTraining;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to create training";
      set({ error: errorMessage, loading: false });
      throw new Error(errorMessage);
    }
  },

  updateTraining: async (id: string, data: Partial<Training>) => {
    set({ loading: true, error: null });
    try {
      const validatedData: Partial<Training> = {
        ...data,
        category: data.category || "Fire Safety",
        date: data.date,
        files: Array.isArray(data.files) ? data.files : [],
        trainees: Array.isArray(data.trainees)
          ? data.trainees.map((trainee) => ({
              ...trainee,
              role:
                typeof trainee.role === "object" && trainee.role?.$oid
                  ? trainee.role.$oid
                  : trainee.role || "",
              roleName: trainee.roleName || undefined,
              attendance: trainee.attendance || "Absent",
            }))
          : [],
        tests: data.tests || [],
        moduleType: data.moduleType ?? "fire_safety",
      };

      const response = await updateTraining(id, validatedData);
      const updatedTraining = (
        response.data as unknown as { success: boolean; data: Training }
      ).data;
      set((state) => ({
        trainings: state.trainings.map((training) =>
          training.id === id ? updatedTraining : training,
        ),
        loading: false,
      }));
      return updatedTraining;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to update training",
        loading: false,
      });
      throw err;
    }
  },

  toggleTrainingStatus: async (id: string) => {
    set({ loading: true, error: null });
    try {
      const response = await toggleTrainingStatusApi(id);
      const updatedTraining = (
        response.data as unknown as { success: boolean; data: Training }
      ).data;
      set((state) => ({
        trainings: state.trainings.map((training) =>
          training.id === id ? updatedTraining : training,
        ),
        loading: false,
      }));
      return updatedTraining;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to toggle status",
        loading: false,
      });
      throw err;
    }
  },

  deleteTraining: async (id: string) => {
    set({ loading: true, error: null });
    try {
      await deleteTrainingApi(id);
      set((state) => ({
        trainings: state.trainings.filter((training) => training.id !== id),
        loading: false,
      }));
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to delete training",
        loading: false,
      });
      throw err;
    }
  },

  updateAttendance: async (
    id: string,
    updates: {
      traineeId: string;
      attendance: "Present" | "Absent";
      testCategory: "Pre-Test" | "Post-Test";
    }[],
    tenantId: string,
  ) => {
    set({ loading: true, error: null });
    try {
      const response = await updateAttendanceApi(id, updates, tenantId); // 👈 tenantId now passed
      const updatedTraining = (
        response.data as unknown as { success: boolean; data: Training }
      ).data;
      set((state) => ({
        trainings: state.trainings.map((training) =>
          training.id === id ? updatedTraining : training,
        ),
        loading: false,
      }));
    } catch (err) {
      set({
        error:
          err instanceof Error ? err.message : "Failed to update attendance",
        loading: false,
      });
      throw err;
    }
  },

  createTest: async (data: Omit<Test, "id">) => {
    set({ loading: true, error: null });
    try {
      const validatedData: Partial<Test> = {
        ...data,
        testCategory: data.testCategory || "Pre-Test",
      };
      const response = await createTest(validatedData);
      const newTest = (
        response.data as unknown as { success: boolean; data: Test }
      ).data;
      set((state) => ({
        tests: [...state.tests, newTest],
        loading: false,
      }));
      return newTest;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to create test",
        loading: false,
      });
      throw err;
    }
  },

  updateTest: async (id: string, data: Partial<Test>) => {
    set({ loading: true, error: null });
    try {
      const validatedData: Partial<Test> = {
        ...data,
        testCategory: data.testCategory || undefined,
      };
      const response = await updateTest(id, validatedData);
      const updatedTest = (
        response.data as unknown as { success: boolean; data: Test }
      ).data;
      set((state) => ({
        tests: state.tests.map((test) => (test.id === id ? updatedTest : test)),
        loading: false,
      }));
      return updatedTest;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to update test",
        loading: false,
      });
      throw err;
    }
  },

  // getTestById: async (id: string) => {
  //   set({ loading: true, error: null });
  //   try {
  //     const response = await getTestById(id);
  //     const test = response.data as unknown as Test;
  //     set({ loading: false });
  //     return test;
  //   } catch (err) {
  //     set({
  //       error: err instanceof Error ? err.message : "Failed to fetch test",
  //       loading: false,
  //     });
  //     throw err;
  //   }
  // },
  submitTest: async (
    testId: string,
    answers: { questionId: number; selectedOption: number }[],
    traineeId: string,
  ) => {
    set({ loading: true, error: null });
    try {
      const result = await submitTest(testId, answers, traineeId);
      if (!result || typeof result.score !== "number") {
        throw new Error("Invalid API response: No valid score returned");
      }
      set((state) => {
        const updatedTrainings = state.trainings.map((training) => {
          const test = training.tests?.find((t) => t.id === testId);
          if (test && test.trainingId === training.id) {
            const updatedTrainees = training.trainees.map((trainee: Trainee) =>
              trainee.traineeId === traineeId
                ? {
                    ...trainee,
                    results: {
                      ...trainee.results,
                      preTestId:
                        test.testCategory === "Pre-Test"
                          ? testId
                          : (trainee.results?.preTestId ?? null),
                      preTestScore:
                        test.testCategory === "Pre-Test"
                          ? result.score
                          : (trainee.results?.preTestScore ?? null),
                      postTestId:
                        test.testCategory === "Post-Test"
                          ? testId
                          : (trainee.results?.postTestId ?? null),
                      postTestScore:
                        test.testCategory === "Post-Test"
                          ? result.score
                          : (trainee.results?.postTestScore ?? null),
                    },
                  }
                : trainee,
            );
            return { ...training, trainees: updatedTrainees };
          }
          return training;
        });
        return { trainings: updatedTrainings, loading: false };
      });
      return result;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to submit test",
        loading: false,
      });
      throw err;
    }
  },
  fetchTrainingById: async (id: string) => {
    set({ loading: true, error: null });
    try {
      const response = await getTrainingById(id);
      const training = response.data as unknown as Training;
      const normalizedTraining: Training = {
        ...training,
        moduleType: training.moduleType || "fire_safety",
      };
      set({ loading: false }); // Store the fetched training
      return normalizedTraining;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to fetch training",
        loading: false,
      });
      throw err;
    }
  },
  getTestByTrainingId: async (trainingId: string): Promise<Test[]> => {
    set({ loading: true, error: null });
    try {
      const response = await getTestByTrainingIdApi(trainingId);
      const tests = (response.data.results ?? []) as Test[];
      set({ tests, loading: false });
      return tests;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to fetch tests",
        loading: false,
      });
      return [];
    }
  },

  fetchAllTests: async () => {
    set({ loading: true, error: null });
    try {

      const response = await getAllTests();
      const tests = (response.data.results ?? []) as Test[];
      set({ tests, loading: false });
      return tests;
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to fetch tests",
        loading: false,
      });
      throw err;
    }
  },

  // getTestsByTrainer: async (): Promise<Test[]> => {
  //   set({ loading: true, error: null });
  //   try {
  //     const response = await getTestsByTrainerApi();
  //     const tests = (response.data.results ?? []) as Test[];
  //     set({ tests, loading: false });
  //     return tests;
  //   } catch (err) {
  //     set({
  //       error: err instanceof Error ? err.message : "Failed to fetch tests",
  //       loading: false,
  //     });
  //     return [];
  //   }
  // },
}));
// --------- risk assesment -------

interface IRiskAssessment {
  riskAssessment: initialRiskAssObject;
  allRiskAssessments: riskobjectType[];
  searchAllRiskAssessment: riskobjectType[];
  loadingRisks: boolean;
  ras_error: string;
  successMssage: string;
  prevAssessmentSubmitDate: string;
  createRiskAssessment: (
    param: initialRiskAssObject,
    moduleName?: string,
  ) => Promise<void>;
  updateRiskAssessment: (
    param: initialRiskAssObject,
    moduleName?: string,
  ) => Promise<void>;
  deleteRiskAssessment: (id: string) => Promise<void>;
  AssetsTask: (id: string) => Promise<void>;
  fetchAllRiskAssessments: (
    moduleName?: string,
    regionId?: string,
    premiseId?: string,
  ) => Promise<void>;
  fetchRiskAssessmentById: (id: string) => Promise<void>;
  clearMessages: (type?: string) => void;
  searchRiskAssessment: (keyword: string, moduleName?: string) => Promise<void>;

  // --------- hwr -------
  hwrList: hospitalRiskType[];
  getAllHwr: (id: string, moduleName?: string) => Promise<void>;
  createHwr: (data: hospitalRiskType, moduleName?: string) => Promise<void>;
  updateHwr: (data: hospitalRiskType, moduleName?: string) => Promise<void>;
  hwrScore: {
    HospitalWideRiskExistingScore: number | string;
    HospitalWideRiskPreviousScore: number | string;
  };
  deleteHwr: (id: string) => Promise<void>;
  // --------- asr -------
  asrList: areaRiskType[];
  getallAsr: (id: string, moduleName?: string) => Promise<void>;
  createAsr: (data: areaRiskType, moduleName?: string) => Promise<void>;
  updateAsr: (data: areaRiskType, moduleName?: string) => Promise<void>;
  asrScore: {
    AreaSpecificRiskExistingScore: number | string;
    AreaSpecificRiskPreviousScore: number | string;
  };
  deleteAsr: (id: string) => Promise<void>;
  fetchScore: (id: string) => Promise<void>;
  clearData: () => void;
  getSuccessMessage: () => string;
  getErrorMessage: () => string;
}

export const useRiskAssessment = create<IRiskAssessment>((set, get) => ({
  riskAssessment: {
    id: "",
    premises: [],
    premisesName: "",
    addressLine1: "",
    responsiblePerson: [],
    assessor: [],
    assessorEmailAddress: [],
    ImageOfPremises: "",
    suggestedDate: "",
    signature: "",
    status: "open",
  },
  allRiskAssessments: [],
  searchAllRiskAssessment: [],
  loadingRisks: false,
  ras_error: "",
  successMssage: "",
  prevAssessmentSubmitDate: "",
  createRiskAssessment: async (
    param: initialRiskAssObject,
    moduleName?: string,
  ) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await createRiskAssessment(param, moduleName);

      if (response.status === 201 || response.status === 200) {
        set({
          riskAssessment: response.data.message,
          hwrList: response.data.message.HospitalWideRisk,
          asrList: response.data.message.AreaSpecificRisk,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
        toast.success("Risk assessment created successfully");
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
        toast.error("Failed to create risk assessment");
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
      toast.error("Failed to create risk assessment");
    }
  },
  AssetsTask: async (id: any) => {
    try {
      const response = await taskRisk(id);
    } catch (error) {
    }
  },
  updateRiskAssessment: async (param, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await updateRiskAssessment(
        param?._id ?? "",
        param,
        moduleName,
      );
      if (response.data.resCode === 200 || response.status === 200) {
        set({
          riskAssessment: response.data.message,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
        toast.success("Risk assessment updated successfully");
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
        toast.error("Failed to update risk assessment");
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
      toast.error("Failed to update risk assessment");
    }
  },
  deleteRiskAssessment: async (id: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await deleteRiskAssessment(id);
      if (response.data.resCode === 200 || response.status === 200) {
        set({ loadingRisks: false, successMssage: response.data.resMessage });
        toast.success("Risk assessment deleted successfully");
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
        toast.error("Failed to delete risk assessment");
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
      toast.error("Failed to delete risk assessment");
    }
  },
  fetchAllRiskAssessments: async (
    moduleName?: string,
    regionId?: string,
    premiseId?: string,
  ) => {
    set({ loadingRisks: true, ras_error: "" });
    try {
      const response = await getRiskAssesments(moduleName, regionId, premiseId);

      if (response.status === 200) {
        set({
          allRiskAssessments: response.data.message,
          loadingRisks: false,
        });
      } else {
        set({
          ras_error: response.data.resMessage,
          loadingRisks: false,
        });
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({
          ras_error: err.message,
          loadingRisks: false,
        });
      } else {
        set({
          ras_error: "An unknown error occurred",
          loadingRisks: false,
        });
      }
    }
  },
  fetchRiskAssessmentById: async (id) => {
    set({ loadingRisks: true, ras_error: "" });
    try {
      const response = await getRiskAssesmentById(id);
      if (response.data.resCode === 200) {
        set({
          riskAssessment: response.data.message,
          loadingRisks: false,
          hwrList: response.data.message?.HospitalWideRisk,
          asrList: response.data.message?.AreaSpecificRisk,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  searchRiskAssessment: async (keyword: string, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "" });
    try {
      const response = await searchRiskAssessment(keyword, moduleName);
      if (response.status === 200) {
        set({
          searchAllRiskAssessment: response.data.message,
          loadingRisks: false,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  clearMessages: (type) => {
    switch (type) {
      case "success":
        set({ successMssage: "" });
        break;
      case "error":
        set({ ras_error: "" });
        break;
      default:
        set({ successMssage: "", ras_error: "" });
    }
  },

  // ---- hwr ----
  hwrList: [],
  getAllHwr: async (id, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await getAllHwr(id, moduleName);
      if (response.data.resCode === 200) {
        set({
          hwrList: response.data.message,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  createHwr: async (data: hospitalRiskType, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await createhwr(data, moduleName);
      if (response.status === 201) {
        const assessmentId =
          get().riskAssessment?._id || (data as any)?.assessment || "";
        if (isDefined(assessmentId)) {
          await get().getAllHwr(assessmentId, moduleName);
        } else {
          const currentList = get().hwrList;
          const localhwr = JSON.parse(JSON.stringify(currentList));
          localhwr.push(response.data.message);
          set({ hwrList: localhwr });
        }

        set({
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  updateHwr: async (data: hospitalRiskType, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      if (!data._id) {
        set({ ras_error: "There is no id", loadingRisks: false });
        return;
      }
      const response = await updateHwr(data._id ?? "", data, moduleName);
      if (response.data.resCode === 200) {
        const currentList = get().hwrList;
        const localhwr = JSON.parse(JSON.stringify(currentList));
        const currhwri = localhwr.findIndex(
          (e: areaRiskType) => e._id == data._id,
        );
        localhwr[currhwri] = response.data.message;

        set({
          hwrList: localhwr,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  hwrScore: {
    HospitalWideRiskExistingScore: 0,
    HospitalWideRiskPreviousScore: 0,
  },

  deleteHwr: async (id) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await deleteHwr(id);
      if (response.data.resCode === 200) {
        const assessmentId = get().riskAssessment?._id || "";
        if (isDefined(assessmentId)) await get().getAllHwr(assessmentId);
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    } finally {
      set({ loadingRisks: false });
    }
  },

  // ----------- ASR
  asrList: [],
  getallAsr: async (id, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await getAllASR(id, moduleName);
      if (response.data.resCode === 200) {
        set({
          asrList: response.data.message,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  createAsr: async (data: areaRiskType, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await createasr(data, moduleName);
      if (response.status === 201) {
        const assessmentId =
          get().riskAssessment?._id || (data as any)?.assessment || "";
        if (isDefined(assessmentId)) {
          await get().getallAsr(assessmentId, moduleName);
        } else {
          const currentList = get().asrList;
          const localasr = JSON.parse(JSON.stringify(currentList));
          localasr.push(response.data.message);
          set({ asrList: localasr });
        }

        set({
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  updateAsr: async (data: areaRiskType, moduleName?: string) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      if (!data?._id) {
        set({ ras_error: "There is no id", loadingRisks: false });
        return;
      }
      const response = await updateASR(data._id ?? "", data, moduleName);
      if (response.data.resCode === 200) {
        const currentList = get().asrList;
        const localasr = JSON.parse(JSON.stringify(currentList));
        const currasri = localasr.findIndex(
          (e: areaRiskType) => e._id == data._id,
        );
        localasr[currasri] = response.data.message;

        set({
          asrList: localasr,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },
  asrScore: {
    AreaSpecificRiskExistingScore: 0,
    AreaSpecificRiskPreviousScore: 0,
  },

  deleteAsr: async (id) => {
    set({ loadingRisks: true, ras_error: "", successMssage: "" });
    try {
      const response = await deleteASR(id);
      if (response.data.resCode === 200) {
        const assessmentId = get().riskAssessment?._id || "";
        if (isDefined(assessmentId)) await get().getallAsr(assessmentId);
      } else {
        set({ ras_error: response.data.resMessage, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    } finally {
      set({ loadingRisks: false });
    }
  },

  // ----------- Fetch score
  fetchScore: async (id) => {
    try {
      const response = await getAssessmentScore(id);
      if (response.data.status === 200) {
        set({
          asrScore: response.data.message.asrScore,
          hwrScore: response.data.message.hwrScore,
          prevAssessmentSubmitDate: response.data.message.prevSubmittedDate,
          loadingRisks: false,
          successMssage: response.data.resMessage,
        });
      } else {
        set({ ras_error: response.data.error, loadingRisks: false });
      }
    } catch (err: any) {
      if (err instanceof Error) {
        set({ ras_error: err.message, loadingRisks: false });
      } else {
        set({ ras_error: "An unknown error occurred", loadingRisks: false });
      }
    }
  },

  clearData: () => {
    set({
      riskAssessment: {
        _id: "",
        premises: [],
        addressLine1: "",
        responsiblePerson: [],
        assessor: [],
        assessorEmailAddress: [],
        ImageOfPremises: "",
        suggestedDate: "",
        signature: "",
        status: "open",
      },
      hwrList: [],
      asrList: [],
      hwrScore: {
        HospitalWideRiskExistingScore: 0,
        HospitalWideRiskPreviousScore: 0,
      },
      asrScore: {
        AreaSpecificRiskExistingScore: 0,
        AreaSpecificRiskPreviousScore: 0,
      },
      loadingRisks: false,
      ras_error: "",
      successMssage: "",
      prevAssessmentSubmitDate: "",
    });
  },
  getSuccessMessage: () => get().successMssage,
  getErrorMessage: () => get().ras_error,
}));
interface equipments {
  equipmentData: EquipmentObjType[];
  loading: boolean;
  error: boolean | string;
  createAssetsEquipment: (data: Partial<EquipmentObjType>) => Promise<void>;
  updateAssetsEquipment: (
    id: string,
    data: Partial<EquipmentObjType>,
  ) => Promise<void>;
  allAssetsEquipment: () => Promise<void>;
  deleteAssetsEquipment: (id: string) => Promise<void>;

  // Asset Equipment Subcategory methods
  assetSubcategoryData: any[];
  allAssetSubcategories: () => Promise<void>;
  createAssetSubcategory: (data: any) => Promise<void>;
  updateAssetSubcategory: (id: string, data: any) => Promise<void>;
  deleteAssetSubcategory: (id: string) => Promise<void>;
}

export const useEquipmentStore = create<equipments>((set, get) => ({
  equipmentData: [],
  assetSubcategoryData: [],
  loading: false,
  error: false,
  createAssetsEquipment: async (data: Partial<EquipmentObjType>) => {
    try {
      const response = await axiosInstance.post(
        `/api/equipmentinventory`,
        data,
      );
      if (response.status === 201) {
        await get().allAssetsEquipment();
      }
    } catch (error) {
    }
  },
  updateAssetsEquipment: async (
    id: string,
    data: Partial<EquipmentObjType>,
  ) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/equipmentinventory/${id}`, data);
      await get().allAssetsEquipment();
      set({ loading: false });
    } catch (error) {}
  },
  allAssetsEquipment: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/equipmentinventory`);
      set({
        equipmentData: response.data.message || [],
        loading: false,
        error: false,
      });
    } catch (error) {
    }
  },
  deleteAssetsEquipment: async (id: string) => {
    try {
      set({ loading: true, error: false });
      const response = await axiosInstance.delete(
        `/api/equipmentinventory/${id}`,
      );

      await get().allAssetsEquipment();
      set({ loading: false });
    } catch (error) {
    }
  },

  // Asset Equipment Subcategory methods
  allAssetSubcategories: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/asset-subcategory`);
      set({
        assetSubcategoryData: response.data.data || [],
        loading: false,
        error: false,
      });
    } catch (error) {
      set({ loading: false, error: "Failed to fetch asset subcategories" });
    }
  },

  createAssetSubcategory: async (data: any) => {
    try {
      set({ loading: true, error: false });
      const response = await axiosInstance.post(
        `/api/asset-subcategory`,
        data,
      );
      if (response.status === 201) {
        await get().allAssetSubcategories();
      }
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: "Failed to create asset subcategory" });
    }
  },

  updateAssetSubcategory: async (id: string, data: any) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/asset-subcategory/${id}`, data);
      await get().allAssetSubcategories();
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: "Failed to update asset subcategory" });
    }
  },

  deleteAssetSubcategory: async (id: string) => {
    try {
      set({ loading: true, error: false });
      const response = await axiosInstance.delete(
        `/api/asset-subcategory/${id}`,
      );
      if (response.status === 200) {
        await get().allAssetSubcategories();
      }
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: "Failed to delete asset subcategory" });
    }
  },
}));

// --------- asset -------
interface AssetState {
  // equipment and its id
  equipmentInventory: string | null;

  // checks
  checks: initialChecks;
  maintenance: maintenance | null;
  allMaintenance: maintenance[] | null;
  currentMaintenance: maintenance | null;
  allChecks: allChecksType[];
  allAssets: AssetsState[];
  currentAssets: CurrentAssets | null;
  currentChecks: initialChecks | null;
  loading: boolean;
  error: boolean | string;

  // handlers

  createAssetsHandler: (asset: AssetsState) => Promise<void>;
  allChecksHandler: (param: any) => Promise<void>;
  deleteChecksHandler: (id: string) => Promise<void>;
  setCurrentChecks: (checks: initialChecks | null) => void;
  updateChecksHandler: (id: string, data: initialChecks) => void;
  getAllAssetsHandler: () => void;
  updateAssetsHandler: (id: string, data: AssetsState) => Promise<void>;
  getAssetsByIdHandler: (id: string) => Promise<any | null>;
  filterByFloorHandler: (filters: string) => void;
  getAllMaintenanceHandler: (id: string) => void;
  createMaintenanceHandler: (param: maintenance) => Promise<void>;
  getMaintenanceByIdHandler: (id: string) => Promise<any | null>;
  clearData: () => void;
}
export const useAsset = create<AssetState>((set, get) => ({
  equipmentInventory: "",
  equipment: "",
  currentAssets: {
    assets: {} as AssetsState,
    equipmentInventory: "",
    equipmentInventoryName: "",
    equipmentSubCategory: "",
    premisesName: "",
    premisesId: "",
    region: "",
    name: "",
    image: "",
    vendorName: "",
    mobileNumber: "",
    vendorEmail: "",
    // inventory
    inventory: "",
    unitNumber: "",
    manufacture: "",
    type: "",
    installedOn: "",
    totalNumber: "",
    uploadReferenceDocument: "",
    floor: "",
    areaName: "",
    equipmentManufactureDate: "",
    equipmentExpireDate: "",
    checksAssets: [],
    files: [],
    nextInspectionDate: "",
    inspectionStatus: "",
    HB_No: "",
  },
  maintenance: {
    internalExternal: "",
    Checked: "",
    lastDateOfCheck: "",
    checkCompletedBy: "",
    observation: "",
    actionTaken: "",
    recheckDate: "",
    recheckBy: "",
    equipment: [],
    files: [],
    image: "",
  },
  allChecks: [],
  allAssets: [],
  allMaintenance: [],
  checks: <initialChecks>{
    _id: "",

    checkType: "",
    frequency: "",
    nextScheduled: "",
  },

  currentChecks: null,
  currentMaintenance: {
    internalExternal: "",
    Checked: "",
    lastDateOfCheck: "",
    checkCompletedBy: "",
    observation: "",
    actionTaken: "",
    recheckDate: "",
    recheckBy: "",
    equipment: [],
    files: [],
    image: "",
  },
  loading: false,
  error: false,

  allChecksHandler: async (id: any) => {
    set({ loading: true, error: false });
    try {
      const response = await getAllChecks(id);
      if (response.status === 200) {
        set({ allChecks: response.data.message, loading: false });
      } else {
        set({ error: response.data.error });
      }
    } catch (error) {
    }
  },
  deleteChecksHandler: async (id: string) => {
    try {
      const response = await axiosInstance.delete(`/api/checks/${id}`);
      if (response.status === 201) {
        const equipmentId = response.data.message?.equipment || "";
        await get().allChecksHandler(equipmentId);
      } else {
      }
    } catch (error) {
    }
  },
  setCurrentChecks: (checks: initialChecks | null) =>
    set({ currentChecks: checks }),
  updateChecksHandler: async (id: string, data: initialChecks) => {
    try {
      const response = await updateChecks(id, data);

      set({ loading: true, error: false });
      if (response.status === 200) {
        const equipmentId = response.data.message?.equipment || "";
        await get().allChecksHandler(equipmentId);
      } else {
      }
    } catch (error) {
    }
  },
  // create assets
  createAssetsHandler: async (asset: AssetsState) => {
    try {
      const response = await createAssets(asset);
      if (response.status === 201) {
        await get().getAllAssetsHandler();
      }
    } catch (error) {
      console.error("Error creating assets:", error);
      throw error;
    }
  },
  getAllAssetsHandler: async () => {
    try {
      const response = await getAllAssets();
      if (response.status === 200) {
        set({ allAssets: response.data.message });
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
      throw error;
    }
  },

  updateAssetsHandler: async (id: string, data: AssetsState) => {
    try {
      const response = await updateAssets(id, data);

      if (response.status === 200) {
        await get().getAllAssetsHandler();
      } else {
        console.error("Failed to update asset:", response.data);
      }
    } catch (error) {
      console.error("Error updating asset:", error);
      throw error;
    }
  },
  getAssetsByIdHandler: async (id: string) => {
    try {
      const response = await getOneAssets(id);
      if (response.status === 200) {
        set({
          currentAssets: response.data.message,
        });
      } else {
        console.error("Failed to fetch asset by ID:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching asset by ID:", error);
      return null;
    }
  },
  //--------assets filters
  filterByFloorHandler: async (keyword: string) => {
    set({ loading: true, error: false });

    try {
      if (keyword === "Select Floor" || keyword === "Select Equipment") {
        await get().getAllAssetsHandler();
        set({ loading: false });
        return;
      }
      const response = await filterAssetsByFloor(keyword);

      if (response.status === 200) {
        set({ allAssets: response.data.message, loading: false });
      } else {
        set({ error: response.data.error, loading: false });
      }
    } catch (error) {
      console.error("Error filtering assets:", error);
      set({ error: "Failed to filter assets", loading: false });
    }
  },

  // ---- maintenance
  createMaintenanceHandler: async (param: maintenance) => {
    if (param.equipment.length === 0) {
      toast.error("Please select at least one equipment");
      return;
    }
    try {
      const response = await createMaintenance(param);
      if (response.status === 201) {
        set({ maintenance: response.data.message });
        let equipmentId = get().maintenance?.equipment || "";
        if (Array.isArray(equipmentId)) {
          equipmentId = equipmentId[0] || "";
        }
        await get().getAllMaintenanceHandler(equipmentId);
      }
    } catch (error) {
    }
  },
  getAllMaintenanceHandler: async (id: string) => {
    try {
      const response = await getAllMaintenance(id);
      if (response.status === 200) {
        set({ allMaintenance: response.data.message });
      }
    } catch (error) {
    }
  },
  getMaintenanceByIdHandler: async (id: string) => {
    try {
      const response = await getOneMaintenance(id);
      if (response.status === 200) {
        set({ currentMaintenance: response.data.message });
      }
    } catch (error) {
    }
  },
  clearData: () =>
    set({
      equipmentInventory: "",
      currentAssets: null,
      currentMaintenance: null,
      loading: false,
      error: false,
    }),
}));

// --------------- region -------

interface IRegion {
  regions: regionObjectType[];
  error: boolean;
  loading: boolean;

  fetchRegions: () => Promise<void>;
  createRegion: (data: Partial<regionObjectType>) => Promise<void>;
  updateRegionById: (
    id: string,
    data: Partial<regionObjectType>,
  ) => Promise<void>;
  getRegionById: (id: string) => Promise<regionObjectType>;
}

export const useRegionStore = create<IRegion>((set, get) => ({
  regions: [],
  error: false,
  loading: false,

  fetchRegions: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/regions`);
      set({ regions: response?.data?.data || [], loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch Regions data");
    }
  },

  updateRegionById: async (id: string, data: Partial<regionObjectType>) => {
    set({ loading: true, error: false });
    try {
      const payload = data;
      const updatedData = await axiosInstance.put(
        `/api/region/${id}`,
        payload,
      );
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: true });
      console.error("Error updating data: ", error);
      handleApiError(error, "Failed to update Region data");
    }
  },

  createRegion: async (data: Partial<regionObjectType>) => {
    try {
      set({ loading: true, error: false });
      const payload = data;
      const resData = await axiosInstance.post(`/api/region`, payload);
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      console.error("Error submitting data: ", error);
      handleApiError(error, "Failed to create Region data");
    }
  },

  getRegionById: async (id: string) => {
    try {
      const resData: any = await axiosInstance.get(`/api/region/${id}`);
      return resData?.data?.message;
    } catch (error: any) {
      console.error("Error fetching data: ", error);
      handleApiError(error, "Failed to get Region data");
    }
  },
}));

interface IDepartment {
  departments: departmentObjType[];
  loading: boolean;
  error: boolean;
  fetchAllDepartments: () => Promise<void>;
  getDepartmentById: (id: string) => Promise<departmentObjType | null>;
  createDepartment: (data: Partial<departmentObjType>) => Promise<void>;
  updateDepartment: (
    id: string,
    data: Partial<departmentObjType>,
  ) => Promise<void>;
  deleteDepartment: (id: string) => Promise<void>;
}

export const useDepartmentStore = create<IDepartment>((set, get) => ({
  departments: [],
  loading: false,
  error: false,

  fetchAllDepartments: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/departments`);
      set({ departments: response?.data?.data || [], loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch departments data");
    }
  },

  getDepartmentById: async (id: string) => {
    try {
      const response = await axiosInstance.get(`/api/departments/${id}`);
      return response?.data?.data || null;
    } catch (error: any) {
      console.error("Fetch by ID failed:", error.message);
      handleApiError(error, "Failed to fetch department data");
      return null;
    }
  },

  createDepartment: async (data: Partial<departmentObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.post(`/api/departments`, data);
      await get().fetchAllDepartments();
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to create department.");
    }
  },

  updateDepartment: async (id: string, data: Partial<departmentObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/departments/${id}`, data);
      await get().fetchAllDepartments();
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to update department.");
    }
  },

  deleteDepartment: async (id: string) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.delete(`/api/departments/${id}`);
      await get().fetchAllDepartments();
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to delete department.");
    }
  },
}));

interface IRoles {
  rolesData: rolesObjType[];
  loading: boolean;
  error: boolean;
  fetchAllRoles: () => Promise<boolean>;
  createRole: (data: Partial<rolesObjType>) => Promise<string>;
  updateRole: (id: string, data: Partial<rolesObjType>) => Promise<boolean>;
  getRoleById: (id: string) => Promise<boolean>;
}

export const useRoleManageStore = create<IRoles>((set, get) => ({
  rolesData: [],
  selectedRoleId: "",
  loading: false,
  error: false,
  fetchAllRoles: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/roles`);
      set({ rolesData: response?.data?.data || [], loading: false });
      return true;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch Roles data");
      return false;
    }
  },
  createRole: async (data: Partial<rolesObjType>) => {
    try {
      set({ loading: true, error: false });
      const res = await axiosInstance.post(`/api/roles`, data);
      await get().fetchAllRoles();
      set({ loading: false });
      return res.data?.id;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to create Role");
      return false;
    }
  },
  updateRole: async (id: string, data: Partial<rolesObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/roles/${id}`, data);
      await get().fetchAllRoles();
      set({ loading: false });
      return true;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to update Role");
      return false;
    }
  },
  getRoleById: async (id: string) => {
    try {
      const response = await axiosInstance.get(`/api/roles/${id}`);
      return response?.data?.message || null;
    } catch (error: any) {
      console.error("Fetch by ID failed:", error.message);
      handleApiError(error, "Failed to get Role data");
      return null;
    }
  },
}));

// ========== SECURITY ACCESS ZONES STORE ==========
interface IAccessZones {
  zonesData: any[];
  loading: boolean;
  error: boolean | string;
  fetchAllZones: () => Promise<boolean>;
}

export const useAccessZonesStore = create<IAccessZones>((set, get) => ({
  zonesData: [],
  loading: false,
  error: false,
  fetchAllZones: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(
        `/api/security/access-zones`,
      );
      set({
        zonesData: response?.data?.data || response?.data?.message || [],
        loading: false,
      });
      return true;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch Access Zones data");
      return false;
    }
  },
}));

interface IOrgUsers {
  orgUsersData: OrgUserType[];
  orgUsersMap: Map<string, string>;
  loading: boolean;
  error: boolean | string;
  setError: () => Promise<void>;
  fetchOrgUsers: () => Promise<boolean>;
  createOrgUser: (data: Partial<OrgUserType>) => Promise<boolean>;
  updateOrgUser: (id: string, data: Partial<OrgUserType>) => Promise<boolean>;
}

export const useOrgUsersStore = create<any>((set, get) => ({
  orgUsersData: [],
  orgUsersMap: new Map(),
  loading: false,
  error: false,
  setError: (error: any) => set({ error }),
  fetchOrgUsers: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/orgUser/directory`);
      const orgUsersData = response?.data?.data || [];
      const orgUsersMap = new Map<string, string>(
        orgUsersData.map((user: OrgUserType) => [
          user._id,
          `${user.firstName} ${user.lastName}`,
        ]),
      );
      set({
        orgUsersData,
        orgUsersMap,
        loading: false,
        error: false,
      });
      return true;
    } catch (error: any) {
      set({
        // error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch Users data");
      return false;
    }
  },
  createOrgUser: async (data: Partial<OrgUserType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.post(`/api/orgUser/user`, data);
      await get().fetchOrgUsers();
      set({ loading: false });
      return true;
    } catch (error: any) {
      console.error(error, "error creating user");
      if (error.response?.status === 400)
        set({
          error: error.response?.data?.message || error.message,
          loading: false,
        });
      handleApiError(error, "Failed to create Users data");
      return false;
    }
  },
  updateOrgUser: async (id: string, data: Partial<OrgUserType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/orgUser/user/${id}`, data);
      await get().fetchOrgUsers();
      set({ loading: false });
      return true;
    } catch (error: any) {
      if (error.response?.status === 400)
        set({
          error: error.response?.data?.message || error.message,
          loading: false,
        });
      handleApiError(error, "Failed to update Users data");
      console.error("Update user failed:", error.message);
      return false;
    }
  },
}));

interface FireDrillState {
  fireDrillsData: FireDrill[];
  loading: boolean;
  error: boolean | string;

  fetchFireDrillsData: (
    moduleType?: string,
    region?: string,
    premisesId?: string,
  ) => Promise<void>;
  createFireDrill: (fireDrillData: Omit<FireDrill, "id">) => Promise<void>;
  updateFireDrill: (
    fireDrillData: Partial<FireDrill>,
    id: string,
  ) => Promise<void>;
  deleteFireDrill: (id: string) => Promise<void>;
  searchFireDrill: (
    dateRange: {
      from_date: string;
      to_date: string;
    },
    moduleType?: string,
  ) => Promise<void>;
  downloadFireDrill: (moduleType?: string) => Promise<any>;
}

export const useFireDrills = create<FireDrillState>((set, get) => ({
  fireDrillsData: [],
  loading: false,
  error: false,
  fetchFireDrillsData: async (
    moduleType?: string,
    region?: string,
    premisesId?: string,
  ) => {
    set({ loading: true });
    try {
      const params = new URLSearchParams();
      if (moduleType) {
        params.append("moduleType", moduleType);
      }
      if (region) {
        params.append("region", region);
      }

      if (premisesId) {
        params.append("premisesId", premisesId);
      }

      const response = await axiosInstance.get(
        `/api/fire-drills?${params.toString()}`,
      );
      set({ fireDrillsData: response.data.fireDrills });
    } catch (error) {
      set({ loading: false, error: true });
    }
  },
  createFireDrill: async (fireDrillData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.post(
        `/api/fire-drill/create`,
        fireDrillData,
      );
      if (response.status === 201 || response.status === 200) {
        await get().fetchFireDrillsData(fireDrillData.moduleType);
        toast.success("Drill created successfully");
      }
      set({ loading: false });
    } catch (error) {
      toast.error("Fail to create Drill");
      set({ loading: false, error: true });
    }
  },
  updateFireDrill: async (fireDrillData, id) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/fire-drill/${id}`, fireDrillData);
      await get().fetchFireDrillsData(fireDrillData.moduleType);
      toast.success("Drill updated successfully");
      set({ loading: false });
    } catch (error: any) {
      toast.error("Fail to update Drill");
      set({
        loading: false,
        error: error.response?.data?.message || error.message,
      });
    }
  },
  deleteFireDrill: async (id) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.delete(`/api/fire-drill/${id}`);

      await get().fetchFireDrillsData();
      toast.success("Drill deleted successfully");
      set({ loading: false });
    } catch (error: any) {
      toast.error("Fail to delete Drill");
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
    }
  },
  searchFireDrill: async (
    dateRange: {
      from_date: string;
      to_date: string;
    },
    moduleType?: string,
  ) => {
    try {
      set({ loading: true, error: false });
      const params = new URLSearchParams({
        from_date: dateRange.from_date,
        to_date: dateRange.to_date,
      });
      if (moduleType) {
        params.append("moduleType", moduleType);
      }

      const response = await axiosInstance.get(
        `/api/fire-drills/search?${params.toString()}`,
      );
      set({
        fireDrillsData: response.data.fireDrills || response.data,
        loading: false,
      });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
    }
  },
  downloadFireDrill: async (moduleType?: string) => {
    try {
      set({ loading: true });
      const params = new URLSearchParams();
      if (moduleType) {
        params.append("moduleType", moduleType);
      }

      const response = await axiosInstance.get(
        `/api/fire-drill/download?${params.toString()}`,
        {
          responseType: "arraybuffer",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        },
      );
      set({ loading: false });
      return response;
    } catch (error) {
      console.error("Download error:", error);
      throw error;
    }
  },
}));

interface IBudgetCats {
  budgetCategories: budgetCategoryObjType[];
  loading: boolean;
  error: boolean | string;
  fetchBudgetCategories: () => Promise<boolean>;
  createBudgetCategories: (
    data: Partial<budgetCategoryObjType>,
  ) => Promise<void>;
  updateBudgetCategories: (
    id: string,
    data: Partial<budgetCategoryObjType>,
  ) => Promise<boolean>;
  deleteBudgetCategories: (id: string) => Promise<void>;
}

export const useBudgetCategoryStore = create<IBudgetCats>((set, get) => ({
  budgetCategories: [],
  loading: false,
  error: false,
  fetchBudgetCategories: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/budgetcategory/all`);
      set({
        budgetCategories: response?.data?.results || [],
        loading: false,
        error: false,
      });
      return true;
    } catch (error: any) {
      set({
        // error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch categories");
      return false;
    }
  },
  createBudgetCategories: async (data: Partial<budgetCategoryObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.post(`/api/budgetcategory`, data);
      await get().fetchBudgetCategories();
      toast.success("Budget category created successfully");
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to create budget category.");
      toast.error("Failed to create budget category");
    }
  },

  updateBudgetCategories: async (
    id: string,
    data: Partial<budgetCategoryObjType>,
  ) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/budgetcategory/${id}`, data);
      await get().fetchBudgetCategories();
      toast.success("Budget category updated successfully");
      set({ loading: false });
      return true;
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to update budget category.");
      toast.error("Failed to update budget category");
      return false;
    }
  },

  deleteBudgetCategories: async (id: string) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.delete(`/api/budgetcategory/${id}`);
      await get().fetchBudgetCategories();
      toast.success("Budget category deleted successfully");
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to delete budget category.");
      toast.error("Failed to delete budget category");
    }
  },
}));

interface IPolicyTags {
  policyTags: policyTagsObjType[];
  loading: boolean;
  error: boolean | string;
  fetchPolicyTags: () => Promise<boolean>;
  createPolicyTags: (data: Partial<policyTagsObjType>) => Promise<void>;
  updatePolicyTags: (
    id: string,
    data: Partial<policyTagsObjType>,
  ) => Promise<boolean>;
  deletePolicyTags: (id: string) => Promise<void>;
}

export const usePolicyTagStore = create<IPolicyTags>((set, get) => ({
  policyTags: [],
  loading: false,
  error: false,
  fetchPolicyTags: async () => {
    set({ loading: true, error: false });
    try {
      const response = await axiosInstance.get(`/api/policytags/all`);
      set({
        policyTags: response?.data?.results || [],
        loading: false,
        error: false,
      });
      return true;
    } catch (error: any) {
      set({
        // error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch policy tags.");
      return false;
    }
  },
  createPolicyTags: async (data: Partial<policyTagsObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.post(`/api/policytags`, data);
      await get().fetchPolicyTags();
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to create policy tag.");
    }
  },

  updatePolicyTags: async (id: string, data: Partial<policyTagsObjType>) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.put(`/api/policytags/${id}`, data);
      await get().fetchPolicyTags();
      set({ loading: false });
      return true;
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to update policy tag.");
      return false;
    }
  },

  deletePolicyTags: async (id: string) => {
    try {
      set({ loading: true, error: false });
      await axiosInstance.delete(`/api/policytags/${id}`);
      await get().fetchPolicyTags();
      set({ loading: false });
    } catch (error: any) {
      set({ loading: false, error: true });
      handleApiError(error, "Failed to delete policy tag.");
    }
  },
}));

interface IlegalContracts {
  legalContractTypesData: legalContracttypesObjType[];
  loading: boolean;
  error: boolean | string;
  fetchLegalContractTypes: () => Promise<boolean>;
  createLegalContractTypes: (
    data: Partial<legalContracttypesObjType>,
  ) => Promise<void>;
  updateLegalContractTypes: (
    id: string,
    data: Partial<legalContracttypesObjType>,
  ) => Promise<boolean>;
  deleteLegalContractTypes: (id: string) => Promise<void>;
}

export const useLegalContractTypesStore = create<IlegalContracts>(
  (set, get) => ({
    legalContractTypesData: [],
    loading: false,
    error: false,
    fetchLegalContractTypes: async () => {
      set({ loading: true, error: false });
      try {
        const response = await axiosInstance.get(
          `/api/legalcontracts/all`,
        );
        set({
          legalContractTypesData: response?.data?.results || [],
          loading: false,
          error: false,
        });
        return true;
      } catch (error: any) {
        set({
          // error: error.response?.data?.message || error.message,
          loading: false,
        });
        handleApiError(error, "Failed to fetch data.");
        return false;
      }
    },
    createLegalContractTypes: async (
      data: Partial<legalContracttypesObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.post(`/api/legalcontracts`, data);
        await get().fetchLegalContractTypes();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to create legal contract type.");
      }
    },

    updateLegalContractTypes: async (
      id: string,
      data: Partial<legalContracttypesObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.put(`/api/legalcontracts/${id}`, data);
        await get().fetchLegalContractTypes();
        set({ loading: false });
        return true;
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to update legal contract type.");
        return false;
      }
    },

    deleteLegalContractTypes: async (id: string) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.delete(`/api/legalcontracts/${id}`);
        await get().fetchLegalContractTypes();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to delete legal contract type.");
      }
    },
  }),
);

interface IFireRiskProcesses {
  fireRiskProcessessData: fireRiskProcessObjType[];
  loading: boolean;
  error: boolean | string;
  fetchFireRiskProcesses: () => Promise<boolean>;
  createFireRiskProcess: (
    data: Partial<fireRiskProcessObjType>,
  ) => Promise<void>;
  updateFireRiskProcess: (
    id: string,
    data: Partial<fireRiskProcessObjType>,
  ) => Promise<boolean>;
  deleteFireRiskProcess: (id: string) => Promise<void>;
}

export const useFireRiskProcessStore = create<IFireRiskProcesses>(
  (set, get) => ({
    fireRiskProcessessData: [],
    loading: false,
    error: false,
    fetchFireRiskProcesses: async () => {
      set({ loading: true, error: false });
      try {
        const response = await axiosInstance.get(
          `/api/fireriskprocesses/all`,
        );
        set({
          fireRiskProcessessData: response?.data?.results || [],
          loading: false,
          error: false,
        });
        return true;
      } catch (error: any) {
        set({
          // error: error.response?.data?.message || error.message,
          loading: false,
        });
        handleApiError(error, "Failed to fetch data.");
        return false;
      }
    },
    createFireRiskProcess: async (data: Partial<fireRiskProcessObjType>) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.post(`/api/fireriskprocesses`, data);
        await get().fetchFireRiskProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to create fire risk process.");
      }
    },

    updateFireRiskProcess: async (
      id: string,
      data: Partial<fireRiskProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.put(`/api/fireriskprocesses/${id}`, data);
        await get().fetchFireRiskProcesses();
        set({ loading: false });
        return true;
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to update fire risk process.");
        return false;
      }
    },

    deleteFireRiskProcess: async (id: string) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.delete(`/api/fireriskprocesses/${id}`);
        await get().fetchFireRiskProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to delete fire risk process.");
      }
    },
  }),
);

interface IFireRiskSubProcesses {
  fireRiskSubProcessData: fireRiskSubProcessObjType[];
  loading: boolean;
  error: boolean | string;
  fetchFireRiskSubProcesses: () => Promise<boolean>;
  createFireRiskSubProcess: (
    data: Partial<fireRiskSubProcessObjType>,
  ) => Promise<void>;
  updateFireRiskSubProcess: (
    id: string,
    data: Partial<fireRiskSubProcessObjType>,
  ) => Promise<boolean>;
  deleteFireRiskSubProcess: (id: string) => Promise<void>;
}

export const useFireRiskSubProcessStore = create<IFireRiskSubProcesses>(
  (set, get) => ({
    fireRiskSubProcessData: [],
    loading: false,
    error: false,
    fetchFireRiskSubProcesses: async () => {
      set({ loading: true, error: false });
      try {
        const response = await axiosInstance.get(
          `/api/firerisksubprocesses/all`,
        );
        set({
          fireRiskSubProcessData: response?.data?.results || [],
          loading: false,
          error: false,
        });
        return true;
      } catch (error: any) {
        set({
          // error: error.response?.data?.message || error.message,
          loading: false,
        });
        handleApiError(error, "Failed to fetch data.");
        return false;
      }
    },
    createFireRiskSubProcess: async (
      data: Partial<fireRiskSubProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.post(`/api/firerisksubprocesses`, data);
        await get().fetchFireRiskSubProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to create fire risk sub-process.");
      }
    },

    updateFireRiskSubProcess: async (
      id: string,
      data: Partial<fireRiskSubProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.put(`/api/firerisksubprocesses/${id}`, data);
        await get().fetchFireRiskSubProcesses();
        set({ loading: false });
        return true;
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to update fire risk sub-process.");
        return false;
      }
    },

    deleteFireRiskSubProcess: async (id: string) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.delete(`/api/firerisksubprocesses/${id}`);
        await get().fetchFireRiskSubProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(error, "Failed to delete fire risk sub-process.");
      }
    },
  }),
);

// Hazardous Material Risk Processes Store
interface IHazardousMaterialRiskProcesses {
  hazardousMaterialRiskProcessessData: fireRiskProcessObjType[];
  loading: boolean;
  error: boolean | string;
  fetchHazardousMaterialRiskProcesses: () => Promise<boolean>;
  createHazardousMaterialRiskProcess: (
    data: Partial<fireRiskProcessObjType>,
  ) => Promise<void>;
  updateHazardousMaterialRiskProcess: (
    id: string,
    data: Partial<fireRiskProcessObjType>,
  ) => Promise<boolean>;
  deleteHazardousMaterialRiskProcess: (id: string) => Promise<void>;
}

export const useHazardousMaterialRiskProcessStore =
  create<IHazardousMaterialRiskProcesses>((set, get) => ({
    hazardousMaterialRiskProcessessData: [],
    loading: false,
    error: false,
    fetchHazardousMaterialRiskProcesses: async () => {
      set({ loading: true, error: false });
      try {
        const response = await axiosInstance.get(
          `/api/hazardousmaterialriskprocesses/all`,
        );
        set({
          hazardousMaterialRiskProcessessData: response?.data?.results || [],
          loading: false,
          error: false,
        });
        return true;
      } catch (error: any) {
        set({
          loading: false,
        });
        handleApiError(error, "Failed to fetch data.");
        return false;
      }
    },
    createHazardousMaterialRiskProcess: async (
      data: Partial<fireRiskProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.post(
          `/api/hazardousmaterialriskprocesses`,
          data,
        );
        await get().fetchHazardousMaterialRiskProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to create hazardous material risk process.",
        );
      }
    },

    updateHazardousMaterialRiskProcess: async (
      id: string,
      data: Partial<fireRiskProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.put(
          `/api/hazardousmaterialriskprocesses/${id}`,
          data,
        );
        await get().fetchHazardousMaterialRiskProcesses();
        set({ loading: false });
        return true;
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to update hazardous material risk process.",
        );
        return false;
      }
    },

    deleteHazardousMaterialRiskProcess: async (id: string) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.delete(
          `/api/hazardousmaterialriskprocesses/${id}`,
        );
        await get().fetchHazardousMaterialRiskProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to delete hazardous material risk process.",
        );
      }
    },
  }));

// Hazardous Material Risk SubProcesses Store
interface IHazardousMaterialRiskSubProcesses {
  hazardousMaterialRiskSubProcessData: fireRiskSubProcessObjType[];
  loading: boolean;
  error: boolean | string;
  fetchHazardousMaterialRiskSubProcesses: () => Promise<boolean>;
  createHazardousMaterialRiskSubProcess: (
    data: Partial<fireRiskSubProcessObjType>,
  ) => Promise<void>;
  updateHazardousMaterialRiskSubProcess: (
    id: string,
    data: Partial<fireRiskSubProcessObjType>,
  ) => Promise<boolean>;
  deleteHazardousMaterialRiskSubProcess: (id: string) => Promise<void>;
}

export const useHazardousMaterialRiskSubProcessStore =
  create<IHazardousMaterialRiskSubProcesses>((set, get) => ({
    hazardousMaterialRiskSubProcessData: [],
    loading: false,
    error: false,
    fetchHazardousMaterialRiskSubProcesses: async () => {
      set({ loading: true, error: false });
      try {
        const response = await axiosInstance.get(
          `/api/hazardousmaterialrisksubprocesses/all`,
        );
        set({
          hazardousMaterialRiskSubProcessData: response?.data?.results || [],
          loading: false,
          error: false,
        });
        return true;
      } catch (error: any) {
        set({
          loading: false,
        });
        handleApiError(error, "Failed to fetch data.");
        return false;
      }
    },
    createHazardousMaterialRiskSubProcess: async (
      data: Partial<fireRiskSubProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.post(
          `/api/hazardousmaterialrisksubprocesses`,
          data,
        );
        await get().fetchHazardousMaterialRiskSubProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to create hazardous material risk sub-process.",
        );
      }
    },

    updateHazardousMaterialRiskSubProcess: async (
      id: string,
      data: Partial<fireRiskSubProcessObjType>,
    ) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.put(
          `/api/hazardousmaterialrisksubprocesses/${id}`,
          data,
        );
        await get().fetchHazardousMaterialRiskSubProcesses();
        set({ loading: false });
        return true;
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to update hazardous material risk sub-process.",
        );
        return false;
      }
    },

    deleteHazardousMaterialRiskSubProcess: async (id: string) => {
      try {
        set({ loading: true, error: false });
        await axiosInstance.delete(
          `/api/hazardousmaterialrisksubprocesses/${id}`,
        );
        await get().fetchHazardousMaterialRiskSubProcesses();
        set({ loading: false });
      } catch (error: any) {
        set({ loading: false, error: true });
        handleApiError(
          error,
          "Failed to delete hazardous material risk sub-process.",
        );
      }
    },
  }));

interface IDashboardFs {
  dashboardData: DashboardDataType | null;
  loading: boolean;
  error: boolean | string;
  fetchDashboardData: (args?: FetchDashboardArgs) => Promise<boolean>;
}

export const useDashboardFsStore = create<IDashboardFs>((set, get) => ({
  dashboardData: null,
  loading: false,
  error: false,
  fetchDashboardData: async (args = {}) => {
    set({ loading: true, error: false });
    try {
      const cleanedArgs = Object.fromEntries(
        Object.entries(args).filter(([_, v]) => v !== undefined),
      );

      const queryParams = new URLSearchParams(cleanedArgs).toString();

      const response = await axiosInstance.get(`/api/dashboard?${queryParams}`);
      set({
        dashboardData: response?.data?.data || null,
        loading: false,
        error: false,
      });
      return true;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || error.message,
        loading: false,
      });
      handleApiError(error, "Failed to fetch data.");
      return false;
    }
  },
}));

interface LawsAndRegulationsAudits {
  // states
  audits: LawsAndRegulationsAudit[];
  currentAudit: LawsAndRegulationsAudit | null;
  reminders: AuditReminder[];
  loading: boolean;
  error: string | null;

  // functions
  fetchAllAudits: (params?: any) => Promise<void>;
  fetchAuditById: (id: string) => Promise<void>;
  createAudit: (data: CreateAuditFormData) => Promise<void>;
  updateAudit: (id: string, data: UpdateAuditFormData) => Promise<void>;
  deleteAudit: (id: string) => Promise<void>;
  searchAudits: (keyword: string) => Promise<void>;
  uploadReportFile: (id: string, file: File) => Promise<void>;
  uploadClosureFile: (id: string, file: File) => Promise<void>;
  fetchReminders: () => Promise<void>;
  clearAudits: () => void;
  setCurrentAudit: (audit: LawsAndRegulationsAudit | null) => void;
}
interface FireSafetyAudits {
  // states
  createChecklistState: CreateCheckListForm | null;
  allChickList: CheckListItem[];
  currentChecklist: CheckListItem | null;
  allAudits: Audit[];
  currentAudits: Audit | null;
  // functions
  createCheckList: (
    param: CreateCheckListForm,
    moduleName: string,
  ) => Promise<void>;
  getAllChecklist: (moduleName: string) => Promise<void>;
  deleteChickList: (id: string, moduleName: string) => Promise<void>;
  searchCheckList: (keyword: string, moduleName: string) => Promise<void>;
  getCheckList: (id: string, moduleName: string) => Promise<void>;
  updateCheckList: (
    id: string,
    data: CreateCheckListForm,
    moduleName: string,
  ) => Promise<void>;
  // audits
  createAudit: (data: AuditFormData, moduleName: string) => Promise<void>;
  getAllAudits: (moduleName: string, regionId?: string, premiseId?: string) => Promise<void>;
  getAudit: (id: string) => Promise<void>;
  updateAudit: (
    id: string,
    data: AuditFormData,
    moduleName: string,
  ) => Promise<void>;
  deleteAudit: (id: string, moduleName: string) => Promise<void>;
  filterAudits: (keyword: string, moduleName: string) => Promise<void>;
}
export const useFireSafetyAudits = create<FireSafetyAudits>((set, get) => ({
  createChecklistState: <CreateCheckListForm>{
    checkList: "",
    itemNo: undefined,
    riskRating: undefined,
    appliesToArea: "",
    auditType: "",
    checkListDescription: "",
    isActive: true,
    moduleName: "",
  },
  currentChecklist: <CheckListItem>{
    _id: "",
    checkList: "",
    itemNo: undefined,
    riskRating: undefined,
    appliesToArea: "",
    auditType: "",
    isActive: true,
    moduleName: "",
  },
  currentAudits: <Audit>{
    _id: "",
    assignedAuditors: "",
    auditId: "",
    startDate: "",
    premise: "",
    department: [],
    auditorName: "",
    audit_status: "Scheduled",
    moduleName: "",
  },

  allChickList: [],
  allAudits: [],
  createCheckList: async (params: CreateCheckListForm, moduleName: string) => {
    try {
      const payload = { ...params, moduleName };
      const response = await createCheck(payload);
      if (response.status === 201) {
        await get().getAllChecklist(moduleName);
        toast.success("Checklist created successfully");
      }
    } catch (error) {
      toast.error("Fail to create Checklist");
    }
  },
  getAllChecklist: async (moduleName: string) => {
    try {
      const response = await axiosInstance.get(
        `/api/checklist?moduleName=${moduleName}`,
      );
      if (response.status === 200) {
        set({
          allChickList: response.data.message || [],
        });
      }
    } catch (error) {
      toast.error("Fail to load Checklists");
    }
  },
  deleteChickList: async (id: string, moduleName: string) => {
    try {
      const response = await axiosInstance.delete(
        `/api/checklist/${id}?moduleName=${moduleName}`,
      );
      if (response.status === 200) {
        await get().getAllChecklist(moduleName);
        toast.success("Checklist deleted successfully");
      }
    } catch (error) {
      toast.error("Fail to delete Checklist");
    }
  },
  getCheckList: async (id: string, moduleName: string) => {
    try {
      const response = await axiosInstance.get(
        `/api/checklist/${id}?moduleName=${moduleName}`,
      );
      if (response.status === 200) {
        set({ currentChecklist: response.data.message || null });
      }
    } catch (error) {
      toast.error("Fail to get Checklist");
    }
  },
  updateCheckList: async (
    id: string,
    data: CreateCheckListForm,
    moduleName: string,
  ) => {
    try {
      const response = await axiosInstance.put(
        `/api/checklist/${id}?moduleName=${moduleName}`,
        data,
      );
      if (response.status === 200) {
        await get().getAllChecklist(moduleName);
        toast.success("Checklist updated successfully");
      }
    } catch (error) {
      toast.error("Fail to update Checklist");
    }
  },
  // search
  searchCheckList: async (keyword: string, moduleName: string) => {
    if (keyword.length === 1) {
      await get().getAllChecklist(moduleName);
      return;
    }
    try {
      const response = await axiosInstance.get(
        `/api/checklist/search/${keyword}?moduleName=${moduleName}`,
      );
      if (response.status === 200) {
        set({ allChickList: response.data.message || [] });
      }
    } catch (error) {
      toast.error("Fail to search Checklists");
    }
  },
  // audits
  createAudit: async (data: AuditFormData, moduleName: string) => {
    try {
      const payload = { ...data, moduleName };
      const response = await axiosInstance.post(`/api/audits`, payload);
      if (response.status === 201) {
        await get().getAllAudits(moduleName);
        toast.success("Audit created successfully");
      }
    } catch (error) {
      toast.error("Fail to create Audit");
    }
  },

  getAllAudits: async (
    moduleName: string,
    regionId?: string,
    premiseId?: string
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("moduleName", moduleName);

      if (regionId) {
        params.append("regionId", regionId);
      }

      if (premiseId) {
        params.append("premiseId", premiseId);
      }

      const response = await axiosInstance.get(
        `/api/audits?${params.toString()}`
      );
      if (response.status === 200) {
        set({
          allAudits: response.data.message || [],
        });
      }
    } catch (error) {
      toast.error("Fail to load Audits");
    }
  },
  updateAudit: async (id: string, data: AuditFormData, moduleName: string) => {
    try {
      const payload = { ...data, moduleName };
      const response = await axiosInstance.put(
        `/api/audits/${id}`,
        payload,
      );
      if (response.status === 200) {
        await get().getAllAudits(moduleName);
        toast.success("Audit updated successfully");
      }
    } catch (error) {
      toast.error("Fail to update Audit");
    }
  },
  getAudit: async (id: string) => {
    try {
      const response = await axiosInstance.get(`/api/audits/${id}`);
      if (response.status === 200) {
        set({ currentAudits: response.data.message });
      }
    } catch (error) {
      toast.error("Fail to get Audit");
    }
  },
  deleteAudit: async (id: string, moduleName: string) => {
    try {
      const response = await axiosInstance.delete(
        `/api/audits/${id}?moduleName=${moduleName}`,
      );
      if (response.status === 200) {
        await get().getAllAudits(moduleName);
        toast.success("Audit deleted successfully");
      }
    } catch (error) {
      toast.error("Fail to delete Audit");
    }
  },
  // filters
  filterAudits: async (keyword: string, moduleName: string) => {
    try {
      if (keyword === "") {
        await get().getAllAudits(moduleName);
        return;
      }
      const response = await axiosInstance.get(
        `/api/audits/filter/${keyword}`,
      );
      if (response.status === 200) {
        set({ allAudits: response.data.message });
      }
    } catch (error) {
    }
  },
}));

interface PerformAudits {
  audits: Audit[];
  loading: boolean;
  error: string | null;
  fetchAudits: (name: string, moduleName: string) => Promise<void>;
  createPerformAudit: (data: {
    questions: {
      [key: string]: {
        question: string;
        isSelected: string;
        risk: string;
        comments: string;
      };
    };
    actionReport: ActionReport;
  }) => Promise<void>;
  currentAudit: PerformAuditData | null;
  fetchAuditsById: (id: string) => Promise<void>;
  updateAudit: (id: string, data: AuditFormData) => Promise<void>;
  clearCurrentAudit: () => void;
}
export const usePerformAudits = create<PerformAudits>((set, get) => ({
  audits: [],
  loading: false,
  error: null,
  currentAudit: null,
  fetchAudits: async (name: string, moduleName: string) => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.get(
        `/api/audits/auditor/${name}?moduleName=${moduleName}`,
      );

      if (response.status === 200) {
        set({ audits: response.data.message });
      }
    } catch (error) {
      set({ error: "An error occurred while fetching audits", loading: false });
    }
  },
  createPerformAudit: async (data) => {
    try {
      const response = await axiosInstance.post(
        `/api/audits/perform`,
        data,
      );
      if (response.status === 200 || response.status === 201) {
        await get().fetchAudits(
          response.data.message.actionReport.assignedAuditors,
          response.data.message.actionReport.moduleName,
        );
        toast.success("Audit performed successfully");
      }
    } catch (error) {
    }
  },
  fetchAuditsById: async (id: string) => {
    try {
      const response = await axiosInstance.get(
        `/api/audits/perform/${id}`,
      );
      if (response.status === 200) {
        set({ currentAudit: response.data.message });
        set({ loading: false });
      }
    } catch (error) {
    }
  },
  updateAudit: async (id: string, data: AuditFormData) => {
    try {
      const response = await axiosInstance.put(
        `/api/audits/perform/${id}`,
        data,
      );

      if (response.status === 200) {
        await get().fetchAudits(
          response.data.message.actionReport.assignedAuditors,
          response.data.message.actionReport.moduleName,
        );
        // toast.success("Audit updated successfully");
      }
    } catch (error) {
      toast.error("Fail to update Audit");
    }
  },
  clearCurrentAudit: () => {
    set({ currentAudit: null });
  },
}));

export interface ChecklistItem {
  id: string;
  question: string;
  type: string;
  weightage: number;
  // add other fields if applicable
}

export interface Washroom {
  _id: string;
  washroomName: string;
  type: string;
  floor: string;
  premises?: string | null;
}

export interface Premises {
  _id: string;
  premisesName: string;
  region?: string | null; // optional region field
}
// Washroom Audit Types
export interface WashroomAuditType {
  _id: string;
  washroomId: {
    _id: string;
    name: string;
    type: string;
    floor: string;
  };
  checklistId: {
    _id: string;
    name: string;
  };
  premises: {
    _id: string;
    premisesName: string;
    region: string;
  };
  auditDate: string;
  status: string;
  photos?: string[];
  remarks?: string;
  completedBy?: string;
  score?: number;
}

export interface CurrentWashroomAuditType {
  _id: string;
  washroomId: string;
  checklistId: string;
  premisesId: string;
  answers: Record<string, boolean | number>;

  auditDate: string;
  status: string;
  photos: string[];
  remarks: string;
  assignedTo: string;
  completedBy: string;
  score: number;

  washroom: Washroom | null;
  checklist: ChecklistItem[];
  premises: Premises | null;
}

// Update the store interface
interface IWashroomAuditStore {
  audits: WashroomAuditType[];
  currentAudit: CurrentWashroomAuditType | null;
  loading: boolean;
  error: string | null;
  fetchAudits: () => Promise<void>;
  createAudit: (auditData: any) => Promise<void>;
  updateAudit: (id: string, auditData: any) => Promise<void>;
  clearAudits: () => void;
  fetchAuditById: (id: string) => Promise<void>;
}

interface IStaffOfIndependentUnits {
  staff: StaffOfIndependentUnits[];
  loading: boolean;
  error: string | null;
  currentStaff: StaffOfIndependentUnits | null;
  independentUnits: IndependentUnit[];
  premisesWithUnits: PremiseWithIndependentUnits[];

  fetchStaff: (params?: any) => Promise<void>;
  fetchStaffById: (id: string) => Promise<void>;
  createStaff: (data: CreateStaffFormData | FormData) => Promise<void>;
  updateStaff: (
    id: string,
    data: UpdateStaffFormData | FormData,
  ) => Promise<void>;
  deleteStaff: (id: string) => Promise<void>;
  searchStaff: (keyword: string) => Promise<void>;
  fetchIndependentUnits: (premiseId: string) => Promise<void>;
  fetchPremisesWithUnits: () => Promise<void>;
  clearStaff: () => void;
  setCurrentStaff: (staff: StaffOfIndependentUnits | null) => void;
}

export const useWashroomAuditStore = create<IWashroomAuditStore>((set) => ({
  audits: [],
  currentAudit: null,
  loading: false,
  error: null,

  fetchAudits: async () => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.get(`/api/washroom-audit`);
      const data = response.data;

      if (data.success) {
        set({ audits: data.audits, loading: false });
      } else {
        set({ error: data.error || "Failed to fetch audits", loading: false });
      }
    } catch (error) {
      set({ error: "An error occurred while fetching audits", loading: false });
    }
  },

  createAudit: async (auditData) => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.post(
        `/api/washroom-audit`,
        auditData,
      );
      if (response.data.success) {
        toast.success("Audit created successfully");
        set((state) => ({ loading: false }));
      }
    } catch (error: any) {
      set({
        error: error.response?.data?.error || "Failed to create audit",
        loading: false,
      });
      toast.error(error.response?.data?.error || "Failed to create audit");
    }
  },

  updateAudit: async (id, auditData) => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.put(
        `/api/washroom-audit/${id}`,
        auditData,
      );
      if (response.data.success) {
        toast.success("Audit updated successfully");
        set((state) => ({ loading: false }));
      }
    } catch (error: any) {
      set({
        error: error.response?.data?.error || "Failed to update audit",
        loading: false,
      });
      toast.error(error.response?.data?.error || "Failed to update audit");
    }
  },

  fetchAuditById: async (id: string) => {
    try {
      set({ loading: true, error: null });
      const response = await axiosInstance.get(
        `/api/washroom-audit/${id}`,
      );
      if (response.status === 200) {
        set({ currentAudit: response.data.data });
        set({ loading: false });
      }
    } catch (error) {
      set({ error: "An error occurred while fetching audit", loading: false });
      toast.error("An error occurred while fetching audit");
    }
  },

  clearAudits: () => {
    set({ audits: [], error: null });
  },
}));

export const useLawsAndRegulationsAudits = create<LawsAndRegulationsAudits>(
  (set, get) => ({
    // states
    audits: [],
    currentAudit: null,
    reminders: [],
    loading: false,
    error: null,

    // functions
    fetchAllAudits: async (params = {}) => {
      try {
        set({ loading: true, error: null });
        const response = await getAllLawsRegulationsAudits(params);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          set({ audits: response.data.message });
        } else {
          set({ error: response.data.resMessage || "Failed to fetch audits" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to fetch audits" });
      } finally {
        set({ loading: false });
      }
    },

    fetchAuditById: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await getLawsRegulationsAuditById(id);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          set({ currentAudit: response.data.message });
        } else {
          set({ error: response.data.resMessage || "Failed to fetch audit" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to fetch audit" });
      } finally {
        set({ loading: false });
      }
    },

    createAudit: async (data: CreateAuditFormData) => {
      try {
        set({ loading: true, error: null });
        const response = await createLawsRegulationsAudit(data);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 201 && response.data.message) {
          const newAudit = response.data.message;
          set((state) => ({
            audits: [...state.audits, newAudit],
          }));
        } else {
          set({ error: response.data.resMessage || "Failed to create audit" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to create audit" });
      } finally {
        set({ loading: false });
      }
    },

    updateAudit: async (id: string, data: UpdateAuditFormData) => {
      try {
        set({ loading: true, error: null });
        const response = await updateLawsRegulationsAudit(id, data);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          const updatedAudit = response.data.message;
          set((state) => ({
            audits: state.audits
              .map((item) => (item._id === id ? updatedAudit : item))
              .filter(
                (item): item is LawsAndRegulationsAudit => item !== undefined,
              ),
            currentAudit: null,
          }));
        } else {
          set({ error: response.data.resMessage || "Failed to update audit" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to update audit" });
      } finally {
        set({ loading: false });
      }
    },

    deleteAudit: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await deleteLawsRegulationsAudit(id);
        // Handle Sails.js response format: response.data.resCode indicates success
        if (response.data.resCode === 200) {
          set((state) => ({
            audits: state.audits.filter((item) => item._id !== id),
          }));
        } else {
          set({ error: response.data.resMessage || "Failed to delete audit" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to delete audit" });
      } finally {
        set({ loading: false });
      }
    },

    searchAudits: async (keyword: string) => {
      try {
        set({ loading: true, error: null });
        const response = await searchLawsRegulationsAudits(keyword);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          set({ audits: response.data.message });
        } else {
          set({ error: response.data.resMessage || "Failed to search audits" });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to search audits" });
      } finally {
        set({ loading: false });
      }
    },

    uploadReportFile: async (id: string, file: File) => {
      try {
        set({ loading: true, error: null });
        const response = await uploadAuditReportFile(id, file);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          const updatedAudit = response.data.message;
          set((state) => ({
            audits: state.audits
              .map((item) => (item._id === id ? updatedAudit : item))
              .filter(
                (item): item is LawsAndRegulationsAudit => item !== undefined,
              ),
            currentAudit: updatedAudit,
          }));
        } else {
          set({
            error: response.data.resMessage || "Failed to upload report file",
          });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to upload report file" });
      } finally {
        set({ loading: false });
      }
    },

    uploadClosureFile: async (id: string, file: File) => {
      try {
        set({ loading: true, error: null });
        const response = await uploadAuditClosureFile(id, file);
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          const updatedAudit = response.data.message;
          set((state) => ({
            audits: state.audits
              .map((item) => (item._id === id ? updatedAudit : item))
              .filter(
                (item): item is LawsAndRegulationsAudit => item !== undefined,
              ),
            currentAudit: updatedAudit,
          }));
        } else {
          set({
            error: response.data.resMessage || "Failed to upload closure file",
          });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to upload closure file" });
      } finally {
        set({ loading: false });
      }
    },

    fetchReminders: async () => {
      try {
        set({ loading: true, error: null });
        const response = await getAuditReminders();
        // Handle Sails.js response format: response.data.message contains the data
        if (response.data.resCode === 200 && response.data.message) {
          set({ reminders: response.data.message });
        } else {
          set({
            error: response.data.resMessage || "Failed to fetch reminders",
          });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to fetch reminders" });
      } finally {
        set({ loading: false });
      }
    },

    clearAudits: () => {
      set({ audits: [], currentAudit: null, reminders: [], error: null });
    },

    setCurrentAudit: (audit: LawsAndRegulationsAudit | null) => {
      set({ currentAudit: audit });
    },
  }),
);

// Laws and Regulations Tasks Store
export const useLawsAndRegulationsTaskStore =
  create<LawsAndRegulationsTaskState>((set, get) => ({
    tasks: [],
    loading: false,
    error: null,
    currentTask: null,

    fetchTasks: async () => {
      try {
        set({ loading: true, error: null });
        const response = await getAllLawsRegulationsTasks();
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && Array.isArray(response.data)) {
          set({ tasks: response.data, loading: false });
        } else {
          set({ error: "Failed to fetch tasks", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to fetch tasks",
          loading: false,
        });
      }
    },

    fetchTaskById: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await getLawsRegulationsTaskById(id);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data) {
          const task = response.data as unknown as LawsAndRegulationsTask;
          set({ currentTask: task, loading: false });
        } else {
          set({ error: "Failed to fetch task", loading: false });
        }
      } catch (error: any) {
        set({ error: error.message || "Failed to fetch task", loading: false });
      }
    },

    createTask: async (taskData: CreateTaskFormData) => {
      try {
        set({ loading: true, error: null });
        const response = await createLawsRegulationsTask(taskData);

        // Handle different possible response formats
        let newTask: LawsAndRegulationsTask | null = null;
        let isSuccess = false;

        // Check for Sails.js format: response.data.success && response.data.data
        if (response.data && response.data.success && response.data.data) {
          newTask = response.data.data as unknown as LawsAndRegulationsTask;
          isSuccess = true;
        }
        // Check for direct data format: response.data (without success wrapper)
        else if (
          response.data &&
          ((response.data as any).id || (response.data as any)._id)
        ) {
          newTask = response.data as unknown as LawsAndRegulationsTask;
          isSuccess = true;
        }
        // Check for status-based success (status 200/201)
        else if (response.status >= 200 && response.status < 300) {
          // Even if we don't have the task data, consider it successful
          isSuccess = true;
        }

        if (isSuccess) {
          if (newTask) {
            set((state) => ({
              tasks: [...state.tasks, newTask as LawsAndRegulationsTask],
              loading: false,
            }));
          } else {
            set({ loading: false });
          }
          toast.success("Task created successfully");
        } else {
          console.error("Unexpected response format:", response);
          set({ error: "Failed to create task", loading: false });
          toast.error("Failed to create task");
        }
      } catch (error: any) {
        console.error("Error creating task:", error);
        set({
          error: error.message || "Failed to create task",
          loading: false,
        });
        toast.error(error.message || "Failed to create task");
      }
    },

    updateTask: async (id: string, taskData: UpdateTaskFormData) => {
      try {
        set({ loading: true, error: null });
        const response = await updateLawsRegulationsTask(id, taskData);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && response.data.success && response.data.data) {
          const updatedTask = response.data
            .data as unknown as LawsAndRegulationsTask;
          set((state) => ({
            tasks: state.tasks.map((task) =>
              task._id === id || task.id === id ? updatedTask : task,
            ),
            currentTask: updatedTask,
            loading: false,
          }));
          toast.success("Task updated successfully");
        } else {
          set({ error: "Failed to update task", loading: false });
          toast.error("Failed to update task");
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to update task",
          loading: false,
        });
        toast.error(error.message || "Failed to update task");
      }
    },

    deleteTask: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await deleteLawsRegulationsTask(id);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && response.data.success) {
          set((state) => ({
            tasks: state.tasks.filter(
              (task) => task._id !== id && task.id !== id,
            ),
            currentTask:
              state.currentTask?._id === id || state.currentTask?.id === id
                ? null
                : state.currentTask,
            loading: false,
          }));
          toast.success("Task deleted successfully");
        } else {
          set({ error: "Failed to delete task", loading: false });
          toast.error("Failed to delete task");
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to delete task",
          loading: false,
        });
        toast.error(error.message || "Failed to delete task");
      }
    },

    searchTasks: async (keyword: string) => {
      try {
        set({ loading: true, error: null });
        const response = await searchLawsRegulationsTasks(keyword);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && Array.isArray(response.data)) {
          set({ tasks: response.data, loading: false });
        } else {
          set({ error: "Failed to search tasks", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to search tasks",
          loading: false,
        });
      }
    },

    filterTasks: async (filters: any) => {
      try {
        set({ loading: true, error: null });
        const response = await filterLawsRegulationsTasks(filters);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && Array.isArray(response.data)) {
          set({ tasks: response.data, loading: false });
        } else {
          set({ error: "Failed to filter tasks", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to filter tasks",
          loading: false,
        });
      }
    },

    filterTasksByRegion: async (regionName: string) => {
      try {
        set({ loading: true, error: null });
        const response = await filterLawsRegulationsTasksByRegion(regionName);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && Array.isArray(response.data)) {
          set({ tasks: response.data, loading: false });
        } else {
          set({ error: "Failed to filter tasks by region", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to filter tasks by region",
          loading: false,
        });
      }
    },

    completeTask: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await completeLawsRegulationsTask(id);
        // Handle Sails.js response format: response.data contains the data directly
        if (response.data && response.data.success && response.data.data) {
          const updatedTask = response.data
            .data as unknown as LawsAndRegulationsTask;
          set((state) => ({
            tasks: state.tasks.map((task) =>
              task._id === id || task.id === id ? updatedTask : task,
            ),
            currentTask: updatedTask,
            loading: false,
          }));
          toast.success("Task completed successfully");
        } else {
          set({ error: "Failed to complete task", loading: false });
          toast.error("Failed to complete task");
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to complete task",
          loading: false,
        });
        toast.error(error.message || "Failed to complete task");
      }
    },

    setCurrentTask: (task: LawsAndRegulationsTask | null) => {
      set({ currentTask: task });
    },

    clearTasks: () => {
      set({ tasks: [], currentTask: null, error: null });
    },
  }));

export const useStaffOfIndependentUnits = create<IStaffOfIndependentUnits>(
  (set, get) => ({
    staff: [],
    loading: false,
    error: null,
    currentStaff: null,
    independentUnits: [],
    premisesWithUnits: [],

    fetchStaff: async (params = {}) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.get(
          `/api/staff-independent-units`,
          {
            params,
          },
        );
        if (response.data && Array.isArray(response.data)) {
          set({ staff: response.data, loading: false });
        } else {
          set({ error: "Failed to fetch staff", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to fetch staff",
          loading: false,
        });
      }
    },

    fetchStaffById: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.get(
          `/api/staff-independent-units/${id}`,
        );
        if (response.data) {
          set({ currentStaff: response.data, loading: false });
        } else {
          set({ error: "Failed to fetch staff member", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to fetch staff member",
          loading: false,
        });
      }
    },

    createStaff: async (data: CreateStaffFormData | FormData) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.post(
          `/api/staff-independent-units`,
          data
        );
        if (response.data && response.data.success) {
          const newStaff = response.data.staff;
          set((state) => ({
            staff: [...state.staff, newStaff],
            loading: false,
          }));
          toast.success("Staff member created successfully");
        } else {
          set({ error: "Failed to create staff member", loading: false });
          toast.error("Failed to create staff member");
        }
      } catch (error: any) {
        console.error("=== STORE CREATE STAFF ERROR DEBUG ===");
        console.error("API Error Details:", error.response?.data);
        console.error("Error status:", error.response?.status);
        console.error("Error message:", error.message);
        console.error("Full error object:", error);
        console.error("=== END STORE CREATE STAFF ERROR DEBUG ===");
        set({
          error:
            error.response?.data?.error ||
            error.message ||
            "Failed to create staff member",
          loading: false,
        });
        toast.error(
          error.response?.data?.error ||
          error.message ||
          "Failed to create staff member",
        );
      }
    },

    updateStaff: async (id: string, data: UpdateStaffFormData | FormData) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.put(
          `/api/staff-independent-units/${id}`,
          data
        );
        if (response.data && response.data.success) {
          const updatedStaff = response.data.updatedStaff;
          set((state) => ({
            staff: state.staff.map((item) =>
              item._id === id || item.id === id ? updatedStaff : item,
            ),
            currentStaff: null,
            loading: false,
          }));
          toast.success("Staff member updated successfully");
        } else {
          set({ error: "Failed to update staff member", loading: false });
          toast.error("Failed to update staff member");
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to update staff member",
          loading: false,
        });
        toast.error(error.message || "Failed to update staff member");
      }
    },

    deleteStaff: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.delete(
          `/api/staff-independent-units/${id}`,
        );
        if (response.data && response.data.success) {
          set((state) => ({
            staff: state.staff.filter(
              (item) => item._id !== id && item.id !== id,
            ),
            currentStaff:
              state.currentStaff?._id === id || state.currentStaff?.id === id
                ? null
                : state.currentStaff,
            loading: false,
          }));
          toast.success("Staff member deleted successfully");
        } else {
          set({ error: "Failed to delete staff member", loading: false });
          toast.error("Failed to delete staff member");
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to delete staff member",
          loading: false,
        });
        toast.error(error.message || "Failed to delete staff member");
      }
    },

    searchStaff: async (keyword: string) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.get(
          `/api/staff-independent-units`,
          {
            params: { search: keyword },
          },
        );
        if (response.data && Array.isArray(response.data)) {
          set({ staff: response.data, loading: false });
        } else {
          set({ error: "Failed to search staff", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to search staff",
          loading: false,
        });
      }
    },

    fetchIndependentUnits: async (premiseId: string) => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.get(
          `/api/premises/${premiseId}`,
        );
        if (response.data && response.data.independentUnits) {
          set({
            independentUnits: response.data.independentUnits,
            loading: false,
          });
        } else {
          set({ independentUnits: [], loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to fetch independent units",
          loading: false,
        });
      }
    },

    fetchPremisesWithUnits: async () => {
      try {
        set({ loading: true, error: null });
        const response = await axiosInstance.get(`/api/premises`);
        if (response.data && Array.isArray(response.data)) {
          set({ premisesWithUnits: response.data, loading: false });
        } else {
          set({ error: "Failed to fetch premises", loading: false });
        }
      } catch (error: any) {
        set({
          error: error.message || "Failed to fetch premises",
          loading: false,
        });
      }
    },

    clearStaff: () => {
      set({ staff: [], currentStaff: null, error: null });
    },

    setCurrentStaff: (staff: StaffOfIndependentUnits | null) => {
      set({ currentStaff: staff });
    },
  }),
);

// Maintenance Task Store
interface EquipmentManagement {
  maintenanceTasks: MaintenanceTask[];
  equipmentInventory: EquipmentInventory[];
  loading: boolean;
  error: string | null;
  currentTask: MaintenanceTask | null;
  equipmentManagementTasks: EquipmentManagementTask[] | null;

  fetchAllEquipmentInventory: () => Promise<void>;
  fetchAllMaintenanceSchedule: () => Promise<void>;
  fetchMaintenanceScheduleById: (id: string) => Promise<void>;
  createMaintenanceSchedule: (
    task: Omit<MaintenanceTask, "id">,
  ) => Promise<void>;
  updateMaintenanceSchedule: (
    id: string,
    task: Partial<MaintenanceTask>,
  ) => Promise<void>;
  deleteMaintenanceSchedule: (id: string) => Promise<void>;
  searchMaintenanceSchedule: (keyword: string) => Promise<void>;
  filterMaintenanceSchedule: (filters: any) => Promise<void>;
  setCurrentTask: (task: MaintenanceTask | null) => void;
  // task module
  getAllEquipmentManagementTaskHandler: () => Promise<void>;
  updateEquipmentManagementTaskHandler(
    id: string,
    data: EquipmentManagementTask,
  ): Promise<void>;

  clearTasks: () => void;
}

export const useEquipmentManagementStore = create<EquipmentManagement>(
  (set, get) => ({
    maintenanceTasks: [],
    equipmentInventory: [],
    loading: false,
    error: null,
    currentTask: null,
    equipmentManagementTasks: null,
    fetchAllEquipmentInventory: async () => {
      set({ loading: true, error: null });
      try {
        const response = await getAllEquipmentManagementData();
        if (response.status === 200) {
          set({
            equipmentInventory: (response.data?.results ||
              []) as EquipmentInventory[],
            loading: false,
          });
        } else {
          set({
            error:
              (response.data as any)?.message ||
              "Failed to fetch equipment inventory",
            loading: false,
          });
        }
      } catch (error: any) {
        set({
          error:
            error?.response?.data?.message ||
            error?.message ||
            "Failed to fetch equipment inventory",
          loading: false,
        });
      }
    },
    fetchAllMaintenanceSchedule: async () => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.get(
          `/api/equipment-management-tasks`,
        );
        if (response.status === 200) {
          set({ maintenanceTasks: response.data.results, loading: false });
        } else {
          set({
            error:
              response.data?.message || "Failed to fetch maintenance tasks",
            loading: false,
          });
        }
      } catch (error: any) {
        set({
          error:
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch maintenance tasks",
          loading: false,
        });
      }
    },
    fetchMaintenanceScheduleById: async (id: string) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.get(
          `/api/equipment-management-tasks/${id}`,
        );
        if (response.status == 200) {
          set({ currentTask: response.data.message, loading: false });
        } else {
          set({
            error: response.data?.message || "Failed to fetch maintenance task",
            loading: false,
          });
        }
      } catch (error: any) {
        set({
          error:
            error.response?.data?.message ||
            error.message ||
            "Failed to fetch maintenance task",
          loading: false,
        });
      }
    },

    createMaintenanceSchedule: async (task: Omit<MaintenanceTask, "id">) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.post(
          `/api/equipment-management-tasks`,
          task,
        );
        if (response.status === 201) {
          await get().fetchAllMaintenanceSchedule();
          toast.success("Maintenance task created successfully");
        } else {
          set({
            error:
              response.data?.message || "Failed to create maintenance task",
            loading: false,
          });
          toast.error(
            response.data?.message || "Failed to create maintenance task",
          );
        }
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to create maintenance task";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    updateMaintenanceSchedule: async (
      id: string,
      task: Partial<MaintenanceTask>,
    ) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.put(
          `/api/equipment-management-tasks/${id}`,
          task,
        );

        if (response.data && response.data.success) {
          await get().fetchAllMaintenanceSchedule();
          toast.success("Maintenance task updated successfully");
        } else {
          set({
            error:
              response.data?.message || "Failed to update maintenance task",
            loading: false,
          });
          toast.error(
            response.data?.message || "Failed to update maintenance task",
          );
        }
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to update maintenance task";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    deleteMaintenanceSchedule: async (id: string) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.delete(
          `/api/equipment-management-tasks/${id}`,
        );

        if (response.data && response.data.success) {
          await get().fetchAllMaintenanceSchedule();
          toast.success("Maintenance task deleted successfully");
        } else {
          set({
            error:
              response.data?.message || "Failed to delete maintenance task",
            loading: false,
          });
          toast.error(
            response.data?.message || "Failed to delete maintenance task",
          );
        }
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to delete maintenance task";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    searchMaintenanceSchedule: async (keyword: string) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.get(
          `/api/equipment-management-tasks/search/${keyword}`,
        );

        if (response.data && response.data.success) {
          set({ maintenanceTasks: response.data.data || [], loading: false });
        } else {
          set({
            error:
              response.data?.message || "Failed to search maintenance tasks",
            loading: false,
          });
        }
      } catch (error: any) {
        set({
          error:
            error.response?.data?.message ||
            error.message ||
            "Failed to search maintenance tasks",
          loading: false,
        });
      }
    },

    filterMaintenanceSchedule: async (filters: any) => {
      set({ loading: true, error: null });
      try {
        const response = await axiosInstance.post(
          `/api/maintenance-tasks/filter`,
          filters,
        );

        if (response.data && response.data.success) {
          set({ maintenanceTasks: response.data.data || [], loading: false });
        } else {
          set({
            error:
              response.data?.message || "Failed to filter maintenance tasks",
            loading: false,
          });
        }
      } catch (error: any) {
        set({
          error:
            error.response?.data?.message ||
            error.message ||
            "Failed to filter maintenance tasks",
          loading: false,
        });
      }
    },

    setCurrentTask: (task: MaintenanceTask | null) =>
      set({ currentTask: task }),
    getAllEquipmentManagementTaskHandler: async () => {
      try {
        const response = await getAllEquipmentManagementTask();
        if (response.status === 200) {
          set({ equipmentManagementTasks: response.data.data });
        }
      } catch (error) {
        set({
          error: "Failed to fetch equipment management tasks",
          loading: false,
        });
      }
    },

    updateEquipmentManagementTaskHandler: async (
      id: string,
      data: EquipmentManagementTask,
    ) => {
      try {
        const response = await updateEquipmentManagementTask(id, data);
        if (response.status === 200) {
          await get().getAllEquipmentManagementTaskHandler();

          toast.success(response.data.message);
        } else {
          set({
            error: "Failed to update equipment management task",
            loading: false,
          });
          toast.error("Failed to update equipment management task");
        }
      } catch (error) {
        console.error("Error updating equipment management task:", error);
        set({
          error: "Failed to update equipment management task",
          loading: false,
        });
      }
    },
    clearTasks: () =>
      set({ maintenanceTasks: [], currentTask: null, error: null }),
  }),
);
// External Emergency Preparedness Modules
//  =================================Hazard and Vulnerability Assessment
interface hazardousVulnerabilityState {
  hazardousVulnerability: any[];
  loading: boolean;
  error: string | null;
  currentHazardousVulnerability: any | null;
  fetchAllHazardousVulnerability: () => Promise<void>;
  fetchHazardousVulnerabilityById: (id: string) => Promise<void>;
  createHazardousVulnerability: (data: any) => Promise<void>;
  updateHazardousVulnerability: (id: string, data: any) => Promise<void>;
  deleteHazardousVulnerability: (id: string) => Promise<void>;
}
export const useHazardousVulnerabilityStore =
  create<hazardousVulnerabilityState>((set, get) => ({
    hazardousVulnerability: [],
    loading: false,
    error: null,
    currentHazardousVulnerability: null,
    fetchAllHazardousVulnerability: async () => {
      try {
        const response = await getAllHazardousVulnerability();
        if (response.status === 200) {
          set({ hazardousVulnerability: response.data.data });
        }
      } catch (error) {
        set({
          error: "Failed to fetch hazardous vulnerability",
          loading: false,
        });
      }
    },
    fetchHazardousVulnerabilityById: async (id: string) => {
      try {
        const response = await getHazardousVulnerabilityById(id);
        if (response.status === 200) {
          set({ currentHazardousVulnerability: response.data.data });
        }
      } catch (error) {
        set({
          error: "Failed to fetch hazardous vulnerability",
          loading: false,
        });
      }
    },
    createHazardousVulnerability: async (data: any) => {
      try {
        const response = await createHazardousVulnerability(data);
        if (response.status === 200) {
          await get().fetchAllHazardousVulnerability();
          toast.success("Hazardous vulnerability created successfully");
        }
      } catch (error) {
        set({
          error: "Failed to create hazardous vulnerability",
          loading: false,
        });
      }
    },
    updateHazardousVulnerability: async (id: string, data: any) => {
      try {
        const response = await updateHazardousVulnerability(id, data);
        if (response.status === 200) {
          await get().fetchAllHazardousVulnerability();
          toast.success("Hazardous vulnerability updated successfully");
        }
      } catch (error) {
        set({
          error: "Failed to update hazardous vulnerability",
          loading: false,
        });
      }
    },
    deleteHazardousVulnerability: async (id: string) => {
      try {
        const response = await deleteHazardousVulnerability(id);
        if (response.status === 200) {
          await get().fetchAllHazardousVulnerability();
          toast.success("Hazardous vulnerability deleted successfully");
        }
      } catch (error) {
        set({
          error: "Failed to delete hazardous vulnerability",
          loading: false,
        });
      }
    },
  }));

interface ExternalAgenciesState {
  agencies: ExternalAgency[];
  loading: boolean;
  error: string | null;
  fetchAgencies: () => Promise<void>;
  createAgency: (data: Partial<ExternalAgency>) => Promise<void>;
  updateAgency: (id: string, data: Partial<ExternalAgency>) => Promise<void>;
  deleteAgency: (id: string) => Promise<void>;
  searchAgencies: (keyword: string) => Promise<void>;
  exportAgencies: () => Promise<void>;
}

export const useExternalAgenciesStore = create<ExternalAgenciesState>(
  (set) => ({
    agencies: [],
    loading: false,
    error: null,

    fetchAgencies: async () => {
      set({ loading: true, error: null });
      try {
        const response = await getAllExternalAgencies();
        if (response.data.success) {
          set({ agencies: response.data.data || [], loading: false });
        } else {
          set({
            agencies: [],
            loading: false,
            error: "Failed to fetch agencies",
          });
        }
      } catch (error: any) {
        set({
          loading: false,
          error: error.message || "Failed to fetch agencies",
        });
      }
    },

    createAgency: async (data) => {
      set({ loading: true, error: null });
      try {
        const response = await createExternalAgency(data);
        if (response.data.success) {
          // Refresh list
          const fetchRes = await getAllExternalAgencies();
          if (fetchRes.data.success) {
            set({ agencies: fetchRes.data.data || [], loading: false });
          }
        }
      } catch (error: any) {
        set({
          loading: false,
          error: error.message || "Failed to create agency",
        });
        throw error;
      }
    },

    updateAgency: async (id, data) => {
      set({ loading: true, error: null });
      try {
        await updateExternalAgency(id, data);
        // Refresh list
        const fetchRes = await getAllExternalAgencies();
        if (fetchRes.data.success) {
          set({ agencies: fetchRes.data.data || [], loading: false });
        }
      } catch (error: any) {
        set({
          loading: false,
          error: error.message || "Failed to update agency",
        });
        throw error;
      }
    },

    deleteAgency: async (id) => {
      set({ loading: true, error: null });
      try {
        await deleteExternalAgency(id);
        set((state) => ({
          agencies: state.agencies.filter((a) => a.id !== id && a._id !== id),
          loading: false,
        }));
      } catch (error: any) {
        set({
          loading: false,
          error: error.message || "Failed to delete agency",
        });
        throw error;
      }
    },

    searchAgencies: async (keyword) => {
      set({ loading: true, error: null });
      try {
        if (!keyword.trim()) {
          const response = await getAllExternalAgencies();
          if (response.data.success) {
            set({ agencies: response.data.data || [], loading: false });
          }
          return;
        }
        const response = await searchExternalAgencies(keyword);
        if (response.data.success) {
          set({ agencies: response.data.data || [], loading: false });
        }
      } catch (error: any) {
        set({
          loading: false,
          error: error.message || "Failed to search agencies",
        });
      }
    },

    exportAgencies: async () => {
      try {
        const response = await exportExternalAgencies();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `External_Agencies_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("External Agencies exported successfully");
      } catch (error: any) {
        toast.error("Failed to export agencies");
        console.error(error);
      }
    },
  }),
);
// ========== Utility Systems Endpoints ==========
interface AssetInventoryState {
  assetInventory: AssetInventory[];
  loading: boolean;
  error: string | null;
  fetchAssetInventory: () => Promise<void>;
  createAssetInventory: (param: AssetInventory) => Promise<void>;
  updateAssetInventory: (id: string, param: AssetInventory) => Promise<void>;
  deleteAssetInventory: (id: string) => Promise<void>;
  getAssetInventoryById: (id: string) => Promise<void>;
}
export const useAssetInventoryStore = create<AssetInventoryState>(
  (set, get) => ({
    assetInventory: [],
    loading: false,
    error: null,
    fetchAssetInventory: async () => {
      try {
        const response = await getAssetInventory();
        if (response.status === 200) {
          set({ assetInventory: response.data.data });
        }
      } catch (error) {
        set({
          error: "Failed to fetch asset inventory",
          loading: false,
        });
        toast.error("Failed to fetch asset inventory");
      }
    },
    createAssetInventory: async (param: AssetInventory) => {
      try {
        const response = await createAssetInventory(param);
        if (response.status === 201) {
          await get().fetchAssetInventory();
          toast.success("Asset inventory created successfully");
        }
      } catch (error) {
        set({
          error: "Failed to create asset inventory",
          loading: false,
        });
        toast.error("Failed to create asset inventory");
      }
    },
    updateAssetInventory: async (id: string, param: AssetInventory) => {
      try {
        const response = await updateAssetsInventory(id, param);
        if (response.status === 200) {
          await get().fetchAssetInventory();
          toast.success("Asset inventory updated successfully");
        }
      } catch (error) {
        set({
          error: "Failed to update asset inventory",
          loading: false,
        });
      }
    },
    deleteAssetInventory: async (id: string) => {
      try {
        const response = await deleteAssetsInventory(id);
        if (response.status === 200) {
          await get().fetchAssetInventory();
          toast.success("Asset inventory deleted successfully");
        }
      } catch (error) {
        set({
          error: "Failed to delete asset inventory",
          loading: false,
        });
        toast.error("Failed to delete asset inventory");
      }
    },
    getAssetInventoryById: async (id: string) => {
      try {
        const response = await getAssetsInventoryById(id);
        if (response.status === 200) {
          // set({ assetInventory: [response.data.data] });
          toast.success("Asset inventory fetched successfully");
        }
      } catch (error) {
        set({
          error: "Failed to get asset inventory by id",
          loading: false,
        });
        toast.error("Failed to get asset inventory by id");
      }
    },
  }),
);

interface ContractorVendorManagementState {
  contractorVendors: ContractorVendorManagement[];
  loading: boolean;
  error: string | null;
  fetchContractorVendors: () => Promise<void>;
  createContractorVendor: (param: ContractorVendorManagement) => Promise<void>;
  updateContractorVendor: (
    id: string,
    param: ContractorVendorManagement,
  ) => Promise<void>;
  deleteContractorVendor: (id: string) => Promise<void>;
  getContractorVendorById: (
    id: string,
  ) => Promise<ContractorVendorManagement | null>;
}

export const useContractorVendorManagementStore =
  create<ContractorVendorManagementState>((set, get) => ({
    contractorVendors: [],
    loading: false,
    error: null,
    fetchContractorVendors: async () => {
      try {
        set({ loading: true, error: null });
        const response = await getContractorVendors();
        if (response.status === 200) {
          set({ contractorVendors: response.data.data, loading: false });
        } else {
          set({
            error: "Failed to fetch contractor & vendor records",
            loading: false,
          });
          toast.error("Failed to fetch contractor & vendor records");
        }
      } catch (error) {
        set({
          error: "Failed to fetch contractor & vendor records",
          loading: false,
        });
        toast.error("Failed to fetch contractor & vendor records");
      }
    },
    createContractorVendor: async (param: ContractorVendorManagement) => {
      try {
        set({ loading: true, error: null });
        const response = await createContractorVendor(param);
        if (response.status === 201) {
          await get().fetchContractorVendors();
          toast.success("Contractor / vendor created successfully");
        } else {
          toast.error("Failed to create contractor / vendor");
        }
      } catch {
        set({
          error: "Failed to create contractor / vendor",
          loading: false,
        });
        toast.error("Failed to create contractor / vendor");
      } finally {
        set({ loading: false });
      }
    },
    updateContractorVendor: async (
      id: string,
      param: ContractorVendorManagement,
    ) => {
      try {
        set({ loading: true, error: null });
        const response = await updateContractorVendor(id, param);
        if (response.status === 200) {
          await get().fetchContractorVendors();
          toast.success("Contractor / vendor updated successfully");
        } else {
          toast.error("Failed to update contractor / vendor");
        }
      } catch {
        set({
          error: "Failed to update contractor / vendor",
          loading: false,
        });
        toast.error("Failed to update contractor / vendor");
      } finally {
        set({ loading: false });
      }
    },
    deleteContractorVendor: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await deleteContractorVendor(id);
        if (response.status === 200) {
          await get().fetchContractorVendors();
          toast.success("Contractor / vendor deleted successfully");
        } else {
          toast.error("Failed to delete contractor / vendor");
        }
      } catch {
        set({
          error: "Failed to delete contractor / vendor",
          loading: false,
        });
        toast.error("Failed to delete contractor / vendor");
      } finally {
        set({ loading: false });
      }
    },
    getContractorVendorById: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await getContractorVendorById(id);
        if (response.status === 200) {
          return response.data.data as ContractorVendorManagement;
        }
        toast.error("Failed to get contractor / vendor by id");
        return null;
      } catch {
        set({
          error: "Failed to get contractor / vendor by id",
          loading: false,
        });
        toast.error("Failed to get contractor / vendor by id");
        return null;
      } finally {
        set({ loading: false });
      }
    },
  }));
// Utility system master data

interface UtilityAssetTypeState {
  utilityAssetTypes: UtilityAssetTypeListType[];
  loading: boolean;
  error: string | null;
  fetchUtilityAssetTypes: () => Promise<void>;
  createUtilityAssetType: (data: UtilityAssetTypeListType) => Promise<void>;
  updateUtilityAssetType: (
    id: string,
    data: UtilityAssetTypeListType,
  ) => Promise<void>;
  deleteUtilityAssetType: (id: string) => Promise<void>;
}
export const useUtilityAssetTypeStore = create<UtilityAssetTypeState>(
  (set, get) => ({
    utilityAssetTypes: [],
    loading: false,
    error: null,
    fetchUtilityAssetTypes: async () => {
      try {
        const response = await getAllUtilityAssetTypes();
        if (response.status === 200) {
          set({ utilityAssetTypes: response.data.data });
        }
      } catch (error) {
        set({
          error: "Failed to fetch utility asset types",
          loading: false,
        });
        toast.error("Failed to fetch utility asset types");
      }
    },
    createUtilityAssetType: async (data: UtilityAssetTypeListType) => {
      try {
        const response = await createUtilityAssetType(data);
        if (response.status === 201) {
          await get().fetchUtilityAssetTypes();
          toast.success(response.data.message);
        }
      } catch (error) {
        set({
          error: "Failed to create utility asset type",
          loading: false,
        });
        toast.error("Failed to create utility asset type");
      }
    },
    updateUtilityAssetType: async (
      id: string,
      data: UtilityAssetTypeListType,
    ) => {
      try {
        const response = await updateUtilityAssetType(id, data);
        if (response.status === 200) {
          await get().fetchUtilityAssetTypes();
          toast.success("Utility asset type updated successfully");
        }
      } catch (error) {
        set({
          error: "Failed to update utility asset type",
          loading: false,
        });
        toast.error("Failed to update utility asset type");
      }
    },
    deleteUtilityAssetType: async (id: string) => {
      try {
        const response = await deleteUtilityAssetType(id);
        if (response.status === 200) {
          await get().fetchUtilityAssetTypes();
          toast.success("Utility asset type deleted successfully");
        }
      } catch (error) {
        set({
          error: "Failed to delete utility asset type",
          loading: false,
        });
        toast.error("Failed to delete utility asset type");
      }
    },
  }),
);

// ========== Space Management Store ==========
interface SpaceUtilizationState {
  spaceUtilizations: SpaceUtilization[];
  loading: boolean;
  error: string | null;
  fetchSpaceUtilizations: (params?: {
    premiseId?: string;
    projectId?: string;
    utilizationType?: "before" | "after";
    areaId?: string;
    isActive?: boolean;
  }) => Promise<void>;
  createSpaceUtilization: (param: SpaceUtilization) => Promise<void>;
  updateSpaceUtilization: (
    id: string,
    param: SpaceUtilization,
  ) => Promise<void>;
  deleteSpaceUtilization: (id: string) => Promise<void>;
  getSpaceUtilizationById: (id: string) => Promise<SpaceUtilization | null>;
}

export const useSpaceUtilizationStore = create<SpaceUtilizationState>(
  (set, get) => ({
    spaceUtilizations: [],
    loading: false,
    error: null,
    fetchSpaceUtilizations: async (params) => {
      try {
        set({ loading: true, error: null });
        const response = await getSpaceUtilization(params);
        if (response.status === 200) {
          set({
            spaceUtilizations: response.data.data || [],
            loading: false,
          });
        }
      } catch (error) {
        set({
          error: "Failed to fetch space utilization records",
          loading: false,
        });
        toast.error("Failed to fetch space utilization records");
      }
    },
    createSpaceUtilization: async (param: SpaceUtilization) => {
      try {
        set({ loading: true, error: null });
        const response = await createSpaceUtilization(param);
        if (response.status === 201) {
          await get().fetchSpaceUtilizations();
          toast.success("Space utilization record created successfully");
        }
      } catch (error) {
        set({
          error: "Failed to create space utilization record",
          loading: false,
        });
        toast.error("Failed to create space utilization record");
      }
    },
    updateSpaceUtilization: async (id: string, param: SpaceUtilization) => {
      try {
        set({ loading: true, error: null });
        const response = await updateSpaceUtilization(id, param);
        if (response.status === 200) {
          await get().fetchSpaceUtilizations();
          toast.success("Space utilization record updated successfully");
        }
      } catch (error) {
        set({
          error: "Failed to update space utilization record",
          loading: false,
        });
        toast.error("Failed to update space utilization record");
      }
    },
    deleteSpaceUtilization: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await deleteSpaceUtilization(id);
        if (response.status === 200) {
          await get().fetchSpaceUtilizations();
          toast.success("Space utilization record deleted successfully");
        }
      } catch (error) {
        set({
          error: "Failed to delete space utilization record",
          loading: false,
        });
        toast.error("Failed to delete space utilization record");
      }
    },
    getSpaceUtilizationById: async (id: string) => {
      try {
        set({ loading: true, error: null });
        const response = await getSpaceUtilizationById(id);
        if (response.status === 200) {
          set({ loading: false });
          return response.data.data || null;
        }
        return null;
      } catch (error) {
        set({
          error: "Failed to get space utilization record",
          loading: false,
        });
        toast.error("Failed to get space utilization record");
        return null;
      }
    },
  }),
);

// ========== SAFETY & FACILITY ROUNDS ==========
// ==== Round Planning & Scheduling

export const ROUND_PLANNING_AREAS: string[] = [
  "Emergency Department",
  "ICU",
  "OPD",
  "Radiology",
  "Laboratory",
  "Pharmacy",
];

interface roundPlanningStore {
  allRoundPlanning: roundPlanningType[];
  loading: boolean;
  createRoundPlanning: (data: roundPlanningType) => Promise<void>;
  updateRoundPlanning: (data: roundPlanningType, id: string) => Promise<void>;
  getAllRoundPlanning: () => Promise<void>;
  deleteRoundPlanning: (id: string) => Promise<void>;
  getOneRoundPlanning: (id: string) => Promise<void>;
}

export const useRoundPlanningStore = create<roundPlanningStore>((set, get) => ({
  allRoundPlanning: [],
  loading: false,
  createRoundPlanning: async (data) => {
    try {
      const response = await createRoundPlanning(data);
      if (response.status === 201) {
        set({
          allRoundPlanning: [...get().allRoundPlanning, response.data?.data],
        });
        toast.success(response.data?.message || "Round planning created");
        await get().getAllRoundPlanning();
      }
    } catch (error) {
    }
  },
  updateRoundPlanning: async (data, id) => {
    try {
      const response = await updateRoundPlanning(data, id);
      if (response.status === 200) {
        toast.success(response.data?.message || "Round planning updated");
        await get().getAllRoundPlanning();
      }
    } catch (error) {
      console.error("Failed to update Round Planning", error);
      toast.error("Failed to update round planning");
    }
  },
  getAllRoundPlanning: async () => {
    try {
      set({ loading: true });
      const response = await getAllRoundPlanning();
      if (response.status === 200) {
        set({
          allRoundPlanning: response.data?.data || [],
          loading: false,
        });
      } else {
        set({ loading: false });
      }
    } catch (error) {
      console.error("Failed to fetch Round Planning", error);
      set({ loading: false });
      toast.error("Failed to fetch round planning records");
    }
  },
  deleteRoundPlanning: async (id) => {
    try {
      const response = await deleteRoundPlanning(id);
      if (response.status === 200) {
        toast.success(response.data?.message || "Round planning deleted");
        await get().getAllRoundPlanning();
      }
    } catch (error) {
      console.error("Failed to delete Round Planning", error);
      toast.error("Failed to delete round planning");
    }
  },
  getOneRoundPlanning: async (id) => {
    try {
      const response = await getOneRoundPlanning(id);
      if (response.status === 200) {
        // Keep API wired for future use; no state mutation needed right now
        toast.success(
          response.data?.message || "Round planning record fetched",
        );
      }
    } catch (error) {
      console.error("Failed to fetch Round Planning record", error);
      toast.error("Failed to fetch round planning record");
    }
  },
}));
